'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PropTypes = require('prop-types');
var React = require('react');
var react = require('@stitches/react');
var DefaultTokens = require('@xprog/prensa-design-tokens/3-themes/default.json');
var reactResponsiveCarousel = require('react-responsive-carousel');
var lodash = require('lodash');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var DefaultTokens__namespace = /*#__PURE__*/_interopNamespace(DefaultTokens);

var medias_default = {
  xs: "(min-width: 360px)",
  sm: "(min-width: 460px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1016px)",
  xl: "(min-width: 1280px)"
};

var radius_default = {
  unset: "0px",
  default: "3px",
  alternative: "5px",
  rounded: "99px",
  circle: "50%"
};

var sizes_default = {
  0: "0px",
  1: "4px",
  2: "8px",
  3: "12px",
  4: "16px",
  5: "20px",
  6: "24px",
  7: "28px",
  8: "32px",
  9: "36px",
  10: "40px",
  11: "44px",
  12: "48px",
  13: "52px",
  14: "56px",
  15: "60px",
  16: "64px",
  17: "68px",
  18: "72px",
  19: "76px",
  20: "80px",
  21: "84px",
  22: "88px",
  23: "92px",
  24: "96px",
  25: "100px",
  26: "104px",
  27: "108px",
  28: "112px",
  29: "116px",
  30: "120px",
  31: "124px",
  32: "128px",
  33: "132px",
  34: "136px",
  35: "140px",
  36: "144px",
  37: "148px",
  38: "152px",
  39: "156px",
  40: "160px"
};

var __defProp$x = Object.defineProperty;
var __getOwnPropSymbols$y = Object.getOwnPropertySymbols;
var __hasOwnProp$y = Object.prototype.hasOwnProperty;
var __propIsEnum$y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$x = (obj, key, value) => key in obj ? __defProp$x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$y.call(b, prop))
      __defNormalProp$x(a, prop, b[prop]);
  if (__getOwnPropSymbols$y)
    for (var prop of __getOwnPropSymbols$y(b)) {
      if (__propIsEnum$y.call(b, prop))
        __defNormalProp$x(a, prop, b[prop]);
    }
  return a;
};
const p = (value) => ({ padding: value });
const pt = (value) => ({ paddingTop: value });
const pr = (value) => ({ paddingRight: value });
const pb = (value) => ({ paddingBottom: value });
const pl = (value) => ({ paddingLeft: value });
const px = (value) => ({ paddingLeft: value, paddingRight: value });
const py = (value) => ({ paddingTop: value, paddingBottom: value });
const m = (value) => ({ margin: value });
const mt = (value) => ({ marginTop: value });
const mr = (value) => ({ marginRight: value });
const mb = (value) => ({ marginBottom: value });
const ml = (value) => ({ marginLeft: value });
const mx = (value) => ({ marginLeft: value, marginRight: value });
const my = (value) => ({ marginTop: value, marginBottom: value });
const align = (value) => {
  let a = {};
  let ax = {};
  let ay = {};
  const align2 = value[0];
  const alignx = value[1];
  const aligny = value[2];
  switch (align2) {
    case "row":
      a = { flexDirection: "row" };
      break;
    case "row-reverse":
      a = { flexDirection: "row-reverse" };
      break;
    case "column":
      a = { flexDirection: "column" };
      break;
    case "column-reverse":
      a = { flexDirection: "column-reverse" };
      break;
  }
  if (align2 === "column" || align2 === "column-reverse") {
    switch (alignx) {
      case "left":
        ax = { alignItems: "flex-start" };
        break;
      case "center":
        ax = { alignItems: "center" };
        break;
      case "right":
        ax = { alignItems: "flex-end" };
        break;
      case "evenly":
        ax = { justifyContent: "space-evenly" };
        break;
      case "between":
        ax = { justifyContent: "space-between" };
        break;
    }
  }
  if (align2 === "row" || align2 === "row-reverse") {
    switch (alignx) {
      case "left":
        ax = { justifyContent: "flex-start" };
        break;
      case "center":
        ax = { justifyContent: "center" };
        break;
      case "right":
        ax = { justifyContent: "flex-end" };
        break;
      case "evenly":
        ax = { justifyContent: "space-evenly" };
        break;
      case "between":
        ax = { justifyContent: "space-between" };
        break;
    }
  }
  if (align2 === "column" || align2 === "column-reverse") {
    switch (aligny) {
      case "top":
        ay = { justifyContent: "flex-start" };
        break;
      case "middle":
        ay = { justifyContent: "center" };
        break;
      case "bottom":
        ay = { justifyContent: "flex-end" };
        break;
      case "evenly":
        ay = { justifyContent: "space-evenly" };
        break;
      case "between":
        ay = { justifyContent: "space-between" };
        break;
    }
  }
  if (align2 === "row" || align2 === "row-reverse") {
    switch (aligny) {
      case "top":
        ay = { alignItems: "flex-start" };
        break;
      case "middle":
        ay = { alignItems: "center" };
        break;
      case "bottom":
        ay = { alignItems: "flex-end" };
        break;
      case "evenly":
        ay = { justifyContent: "space-evenly" };
        break;
      case "between":
        ay = { justifyContent: "space-between" };
        break;
    }
  }
  return __spreadValues$x(__spreadValues$x(__spreadValues$x({ display: "flex" }, a), ax), ay);
};
const Utils = {
  align,
  p,
  pt,
  pr,
  pb,
  pl,
  px,
  py,
  m,
  mt,
  mr,
  mb,
  ml,
  mx,
  my
};

const PrensaEngine = react.createStitches({
  prefix: "pds",
  media: medias_default,
  theme: {
    colors: DefaultTokens__namespace.colors,
    fontSizes: DefaultTokens__namespace.fontSizes,
    fontWeights: DefaultTokens__namespace.fontWeights,
    lineHeights: DefaultTokens__namespace.lineHeights,
    radii: radius_default,
    sizes: sizes_default,
    space: sizes_default,
    accordion: {
      sizeMaxContent: "max-content",
      sizeSm: "320px",
      sizeMd: "340px",
      sizeLg: "360px",
      sizeFullWidth: "100%"
    },
    drawer: {
      sizeMaxcontent: "max-content",
      sizeSm: "320px",
      sizeMd: "340px",
      sizeLg: "360px",
      sizeFullwidth: "100%",
      innerSpaceSm: "$space$4",
      innerSpaceMd: "$space$6",
      innerSpaceLg: "$space$8",
      backdropZIndex: 10,
      contentZIndex: 100
    },
    iconButton: {
      sizeSmContainerSize: "$space$8",
      sizeMdContainerSize: "$space$10",
      sizeLgContainerSize: "$space$12",
      sizeSmIconSize: "$space$4",
      sizeMdIconSize: "$space$6",
      sizeLgIconSize: "$space$8"
    }
  },
  utils: Utils
});

const Block = PrensaEngine.styled("div");

const StyledIconButton = PrensaEngine.styled("button", {
  align: ["row", "center", "middle"],
  padding: "$0",
  borderStyle: "solid",
  borderWidth: "1px",
  cursor: "pointer",
  variants: {
    roundedCorners: {
      unset: { borderRadius: "$unset" },
      default: { borderRadius: "$default" },
      alternative: { borderRadius: "$alternative" },
      rounded: { borderRadius: "$rounded" },
      circle: { borderRadius: "$circle" }
    },
    size: {
      sm: {
        height: "$iconButton$sizeSmContainerSize",
        width: "$iconButton$sizeSmContainerSize",
        "svg": {
          height: "$iconButton$sizeSmIconSize",
          width: "$iconButton$sizeSmIconSize"
        }
      },
      md: {
        height: "$iconButton$sizeMdContainerSize",
        width: "$iconButton$sizeMdContainerSize",
        "svg": {
          height: "$iconButton$sizeMdIconSize",
          width: "$iconButton$sizeMdIconSize"
        }
      },
      lg: {
        height: "$iconButton$sizeLgContainerSize",
        width: "$iconButton$sizeLgContainerSize",
        "svg": {
          height: "$iconButton$sizeLgIconSize",
          width: "$iconButton$sizeLgIconSize"
        }
      }
    }
  }
});

var __defProp$w = Object.defineProperty;
var __getOwnPropSymbols$x = Object.getOwnPropertySymbols;
var __hasOwnProp$x = Object.prototype.hasOwnProperty;
var __propIsEnum$x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$w = (obj, key, value) => key in obj ? __defProp$w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$x.call(b, prop))
      __defNormalProp$w(a, prop, b[prop]);
  if (__getOwnPropSymbols$x)
    for (var prop of __getOwnPropSymbols$x(b)) {
      if (__propIsEnum$x.call(b, prop))
        __defNormalProp$w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$9 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$x)
    for (var prop of __getOwnPropSymbols$x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const IconButton = (_a) => {
  var _b = _a, {
    children,
    color,
    css,
    icon,
    iconColor,
    variant
  } = _b, otherProps = __objRest$9(_b, [
    "children",
    "color",
    "css",
    "icon",
    "iconColor",
    "variant"
  ]);
  let css_button = {};
  let css_icon = {};
  let css_variant = {};
  switch (variant) {
    case "filled":
      css_variant = {
        backgroundColor: `$${color}`,
        borderColor: `$${color}`,
        "svg": { fill: `$${iconColor ? iconColor : "basicWhite"}` },
        "&:hover": { opacity: "0.8" }
      };
      break;
    case "outlined":
      css_variant = {
        backgroundColor: "transparent",
        borderColor: `$${color}`,
        color: `$${iconColor ? iconColor : color}`,
        "svg": { fill: `$${iconColor ? iconColor : color}` },
        "&:hover": { opacity: "0.8" }
      };
      break;
    case "ghost":
      css_variant = {
        backgroundColor: "transparent",
        borderColor: "transparent",
        color: `$${iconColor ? iconColor : color}`,
        "svg": { fill: `$${iconColor ? iconColor : color}` },
        "&:hover": { opacity: "0.8" }
      };
  }
  if (css) {
    if (css.button) {
      css_button = __spreadValues$w({}, css.button);
    }
    if (css.icon) {
      css_icon = { "svg": __spreadValues$w({}, css.icon) };
    }
  }
  return /* @__PURE__ */ React__default["default"].createElement(StyledIconButton, __spreadValues$w({
    className: "pds-IconButton-root",
    css: __spreadValues$w(__spreadValues$w(__spreadValues$w({}, css_variant), css_button), css_icon)
  }, otherProps), children ? children : icon);
};
IconButton.defaultProps = {
  color: "brandNeutral500",
  size: "md",
  variant: "filled"
};

const StyledA = PrensaEngine.styled("a", {});

var __defProp$v = Object.defineProperty;
var __getOwnPropSymbols$w = Object.getOwnPropertySymbols;
var __hasOwnProp$w = Object.prototype.hasOwnProperty;
var __propIsEnum$w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$v = (obj, key, value) => key in obj ? __defProp$v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$w.call(b, prop))
      __defNormalProp$v(a, prop, b[prop]);
  if (__getOwnPropSymbols$w)
    for (var prop of __getOwnPropSymbols$w(b)) {
      if (__propIsEnum$w.call(b, prop))
        __defNormalProp$v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$8 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$w)
    for (var prop of __getOwnPropSymbols$w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Link = React__default["default"].forwardRef((_a, ref) => {
  var _b = _a, {
    children,
    bypass = false,
    component: CustomLink,
    componentProps,
    componentOptions
  } = _b, rest = __objRest$8(_b, [
    "children",
    "bypass",
    "component",
    "componentProps",
    "componentOptions"
  ]);
  if (bypass === true) {
    return children;
  }
  if (CustomLink) {
    return /* @__PURE__ */ React__default["default"].createElement(CustomLink, __spreadValues$v(__spreadValues$v({}, rest), componentProps), (componentOptions == null ? void 0 : componentOptions.renderOnlyCustomLink) ? /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, children) : /* @__PURE__ */ React__default["default"].createElement(StyledA, __spreadValues$v({
      ref
    }, rest), children));
  }
  return /* @__PURE__ */ React__default["default"].createElement(StyledA, __spreadValues$v({
    ref
  }, rest), children);
});
Link.displayName = "Link";

const extractVariantKeys = () => {
  let variants = {};
  const keys = Object.keys(PrensaEngine.theme.fontSizes);
  keys.forEach((item, key) => {
    const stylesComposition = {
      fontFamily: "$primary",
      fontSize: `$${item}`,
      fontWeight: `$${item}`,
      lineHeight: `$${item}`
    };
    variants[keys[key]] = stylesComposition;
  });
  return variants;
};

const Typography = PrensaEngine.styled("p", {
  variants: {
    as: {
      h1: {},
      h2: {},
      h3: {},
      h4: {},
      h5: {},
      h6: {},
      p: {},
      span: {},
      cite: {},
      li: {}
    },
    variant: extractVariantKeys()
  }
});

const ExpandLessIcon = () => {
  return /* @__PURE__ */ React__default["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    width: "24",
    viewBox: "0 0 48 48"
  }, /* @__PURE__ */ React__default["default"].createElement("path", {
    d: "M14.15 30.75 12 28.6l12-12 12 11.95-2.15 2.15L24 20.85Z"
  }));
};

const ExpandMoreIcon = () => {
  return /* @__PURE__ */ React__default["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    width: "24",
    viewBox: "0 0 48 48"
  }, /* @__PURE__ */ React__default["default"].createElement("path", {
    d: "m24 30.75-12-12 2.15-2.15L24 26.5l9.85-9.85L36 18.8Z"
  }));
};

const AccordionGroup = PrensaEngine.styled("div", {
  borderColor: "$brandNeutral500",
  borderStyle: "solid",
  borderWidth: "1px",
  borderRadius: "$alternative",
  variants: {
    size: {
      maxContent: { width: "$accordion$sizeMaxContent" },
      sm: { width: "$accordion$sizeSm" },
      md: { width: "$accordion$sizeMd" },
      lg: { width: "$accordion$sizeLg" },
      fullWidth: { width: "$accordion$sizeFullWidth" }
    }
  }
});
AccordionGroup.propTypes = {
  size: PropTypes__default["default"].any
};
const AccordionContent = PrensaEngine.styled("section", {
  variants: {
    innerSpace: {
      sm: { p: "$4" },
      md: { p: "$6" },
      lg: { p: "$8" }
    }
  }
});
AccordionContent.propTypes = {
  innerSpace: PropTypes__default["default"].any
};

var __defProp$u = Object.defineProperty;
var __getOwnPropSymbols$v = Object.getOwnPropertySymbols;
var __hasOwnProp$v = Object.prototype.hasOwnProperty;
var __propIsEnum$v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$u = (obj, key, value) => key in obj ? __defProp$u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$v.call(b, prop))
      __defNormalProp$u(a, prop, b[prop]);
  if (__getOwnPropSymbols$v)
    for (var prop of __getOwnPropSymbols$v(b)) {
      if (__propIsEnum$v.call(b, prop))
        __defNormalProp$u(a, prop, b[prop]);
    }
  return a;
};
const AccordionItemGroup = ({
  accordionContentAs,
  accordionTitleAs,
  accordionTitleVariant,
  children,
  customLink,
  customLinkProps,
  css,
  expanded,
  href,
  iconExpandedState,
  icon,
  iconNotExpandedState,
  id,
  innerSpace,
  onClick,
  title
}) => {
  let container_css = {};
  let content_css = {};
  let title_css = { align: ["row", "between", "middle"] };
  let icon_button_css = {};
  let icon_css = {};
  const button_id = `pds-accordion-button-${id}`;
  const section_id = `pds-accordion-section-${id}`;
  if (css && css.accordionItemGroupContainer) {
    container_css = __spreadValues$u({}, css.accordionItemGroupContainer);
  }
  if (css && css.accordionTitle) {
    if (css.accordionTitle.title) {
      title_css = __spreadValues$u(__spreadValues$u({}, title_css), css.accordionTitle.title);
    }
    if (css.accordionTitle.iconButton) {
      icon_button_css = __spreadValues$u({}, css.accordionTitle.iconButton);
    }
    if (css.accordionTitle.icon) {
      icon_css = __spreadValues$u({}, css.accordionTitle.icon);
    }
  }
  if (css && css.accordionContent) {
    content_css = __spreadValues$u(__spreadValues$u({}, content_css), css.accordionContent);
  }
  const renderExpandedStateIcon = () => {
    if (icon) {
      return icon;
    }
    if (iconExpandedState) {
      return iconExpandedState;
    }
    return /* @__PURE__ */ React__default["default"].createElement(ExpandLessIcon, null);
  };
  const renderNotExpandedStateIcon = () => {
    if (icon) {
      return icon;
    }
    if (iconNotExpandedState) {
      return iconNotExpandedState;
    }
    return /* @__PURE__ */ React__default["default"].createElement(ExpandMoreIcon, null);
  };
  const handleClick = (e) => {
    if (onClick) {
      onClick && onClick(e);
    }
  };
  const itemIcon = expanded ? renderExpandedStateIcon() : renderNotExpandedStateIcon();
  return /* @__PURE__ */ React__default["default"].createElement(Block, {
    className: "pds-Accordion-ItemGroup-container",
    css: container_css
  }, /* @__PURE__ */ React__default["default"].createElement(Typography, {
    as: accordionTitleAs,
    "aria-controls": section_id,
    className: "pds-Accordion-ItemGroup-title",
    id: button_id,
    variant: accordionTitleVariant,
    css: title_css
  }, /* @__PURE__ */ React__default["default"].createElement(Link, __spreadValues$u({
    bypass: !href,
    component: customLink,
    href
  }, customLinkProps), title), /* @__PURE__ */ React__default["default"].createElement(Link, __spreadValues$u({
    bypass: children ? true : false,
    component: customLink,
    href
  }, customLinkProps), /* @__PURE__ */ React__default["default"].createElement(IconButton, {
    className: "pds-Accordion-ItemGroup-IconButton",
    variant: "ghost",
    onClick: handleClick,
    icon: itemIcon,
    css: { button: icon_button_css, icon: icon_css }
  }))), /* @__PURE__ */ React__default["default"].createElement(AccordionContent, {
    className: "pds-Accordion-ItemGroup-content",
    as: accordionContentAs,
    id: section_id,
    innerSpace,
    "aria-labelledby": button_id,
    hidden: !expanded,
    css: content_css
  }, children));
};
AccordionItemGroup.defaultProps = {
  accordionTitleAs: "h3",
  accordionTitleVariant: "buttonLabel-default",
  accordionContentAs: "section"
};
AccordionItemGroup.propTypes = {
  id: PropTypes__default["default"].any.isRequired,
  title: PropTypes__default["default"].any.isRequired,
  accordionTitleAs: PropTypes__default["default"].any,
  accordionContentAs: PropTypes__default["default"].any,
  children: PropTypes__default["default"].any,
  css: PropTypes__default["default"].any,
  expanded: PropTypes__default["default"].any,
  icon: PropTypes__default["default"].any,
  iconExpandedState: PropTypes__default["default"].any,
  iconNotExpandedState: PropTypes__default["default"].any,
  innerSpace: PropTypes__default["default"].any,
  onClick: PropTypes__default["default"].any
};

var __defProp$t = Object.defineProperty;
var __defProps$j = Object.defineProperties;
var __getOwnPropDescs$j = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$u = Object.getOwnPropertySymbols;
var __hasOwnProp$u = Object.prototype.hasOwnProperty;
var __propIsEnum$u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$t = (obj, key, value) => key in obj ? __defProp$t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$u.call(b, prop))
      __defNormalProp$t(a, prop, b[prop]);
  if (__getOwnPropSymbols$u)
    for (var prop of __getOwnPropSymbols$u(b)) {
      if (__propIsEnum$u.call(b, prop))
        __defNormalProp$t(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$j = (a, b) => __defProps$j(a, __getOwnPropDescs$j(b));
var __objRest$7 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$u)
    for (var prop of __getOwnPropSymbols$u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Accordion = ({
  accordionContentAs,
  accordionTitleAs,
  accordionTitleVariant,
  customLink,
  css,
  items,
  innerSpace,
  icon,
  iconExpandedState,
  iconNotExpandedState,
  size
}) => {
  const [state, setState] = React.useState(items || []);
  const handleClick = (id) => {
    let itk = 0;
    const item = state.find((i, k) => {
      itk = k;
      return i.id === id;
    });
    const currentState = Object.assign({}, state);
    const updatedItem = __spreadProps$j(__spreadValues$t({}, item), { expanded: item ? !item.expanded : false });
    const updatedState = __spreadProps$j(__spreadValues$t({}, currentState), { [itk]: updatedItem });
    setState(Object.keys(updatedState).map((key) => updatedState[key]));
  };
  let accordiongroup_css = {};
  let accordionitem_css = {};
  if (css) {
    if (css.accordionGroup) {
      accordiongroup_css = __spreadValues$t({}, css.accordionGroup);
    }
    if (css.accordionItemGroup) {
      accordionitem_css = __spreadValues$t({}, css.accordionItemGroup);
    }
  }
  return /* @__PURE__ */ React__default["default"].createElement(AccordionGroup, {
    size,
    css: accordiongroup_css
  }, state.map((_a) => {
    var _b = _a, { id, onClick } = _b, otherProps = __objRest$7(_b, ["id", "onClick"]);
    return /* @__PURE__ */ React__default["default"].createElement(AccordionItemGroup, __spreadValues$t({
      accordionContentAs: otherProps.accordionContentAs ? otherProps.accordionContentAs : accordionContentAs,
      accordionTitleAs: otherProps.accordionTitleAs ? otherProps.accordionTitleAs : accordionTitleAs,
      accordionTitleVariant: otherProps.accordionTitleVariant ? otherProps.accordionTitleVariant : accordionTitleVariant,
      customLink,
      css: accordionitem_css,
      key: id,
      id,
      innerSpace,
      icon: otherProps.icon ? otherProps.icon : icon,
      iconExpandedState: otherProps.iconExpandedState ? otherProps.iconExpandedState : iconExpandedState,
      iconNotExpandedState: otherProps.iconNotExpandedState ? otherProps.iconNotExpandedState : iconNotExpandedState,
      onClick: onClick ? onClick : () => handleClick(id)
    }, otherProps));
  }));
};
Accordion.defaultProps = {
  innerSpace: "md",
  size: "sm"
};
Accordion.propTypes = {
  children: PropTypes__default["default"].any,
  css: PropTypes__default["default"].any,
  items: PropTypes__default["default"].any,
  innerSpace: PropTypes__default["default"].any,
  size: PropTypes__default["default"].any
};

const StyledButton = PrensaEngine.styled("button", {
  align: ["row", "center", "middle"],
  borderStyle: "solid",
  borderWidth: "1px",
  cursor: "pointer",
  py: "$0",
  px: "$3",
  width: "max-content",
  "&:disabled": {
    backgroundColor: "$brandNeutral300",
    borderColor: "$brandNeutral300",
    color: "$brandNeutral500",
    "&:hover": {
      opacity: 1,
      cursor: "not-allowed"
    }
  },
  variants: {
    roundedCorners: {
      alternative: { borderRadius: "$alternative" },
      circle: { borderRadius: "$circle" },
      default: { borderRadius: "$default" },
      rounded: { borderRadius: "$rounded" },
      unset: { borderRadius: "$unset" }
    },
    size: {
      xs: {
        height: "$8"
      },
      sm: {
        height: "$10"
      },
      md: {
        height: "$12"
      },
      lg: {
        height: "$14"
      },
      xl: {
        height: "$16"
      }
    }
  }
});

var __defProp$s = Object.defineProperty;
var __getOwnPropSymbols$t = Object.getOwnPropertySymbols;
var __hasOwnProp$t = Object.prototype.hasOwnProperty;
var __propIsEnum$t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$s = (obj, key, value) => key in obj ? __defProp$s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$t.call(b, prop))
      __defNormalProp$s(a, prop, b[prop]);
  if (__getOwnPropSymbols$t)
    for (var prop of __getOwnPropSymbols$t(b)) {
      if (__propIsEnum$t.call(b, prop))
        __defNormalProp$s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$t)
    for (var prop of __getOwnPropSymbols$t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Button = (_a) => {
  var _b = _a, {
    children,
    color,
    css,
    labelSpacing,
    iconLeft,
    iconRight,
    variant,
    textColor,
    textVariant
  } = _b, otherProps = __objRest$6(_b, [
    "children",
    "color",
    "css",
    "labelSpacing",
    "iconLeft",
    "iconRight",
    "variant",
    "textColor",
    "textVariant"
  ]);
  let css_label_spacing = { px: `$${labelSpacing}` };
  let css_variant = {};
  switch (variant) {
    case "filled":
      css_variant = {
        backgroundColor: `$${color}`,
        borderColor: `$${color}`,
        color: `$${textColor ? textColor : "basicWhite"}`,
        "svg": { fill: `$${textColor ? textColor : "basicWhite"}` },
        "&:hover": { opacity: "0.8" }
      };
      break;
    case "outlined":
      css_variant = {
        backgroundColor: "transparent",
        borderColor: `$${color}`,
        color: `$${textColor ? textColor : color}`,
        "svg": { fill: `$${textColor ? textColor : color}` },
        "&:hover": { opacity: "0.8" }
      };
      break;
    case "ghost":
      css_variant = {
        backgroundColor: "transparent",
        borderColor: "transparent",
        color: `$${textColor ? textColor : color}`,
        "svg": { fill: `$${textColor ? textColor : color}` },
        "&:hover": { opacity: "0.8" }
      };
  }
  let button_css = __spreadValues$s({}, css_variant);
  let label_css = __spreadValues$s({}, css_label_spacing);
  if (css && css.button) {
    button_css = __spreadValues$s(__spreadValues$s({}, button_css), css.button);
  }
  if (css && css.label) {
    label_css = __spreadValues$s(__spreadValues$s({}, label_css), css.label);
  }
  const renderChildren = () => {
    if (typeof children === "string") {
      return /* @__PURE__ */ React__default["default"].createElement(Typography, {
        as: "span",
        variant: textVariant,
        css: label_css
      }, children);
    } else {
      return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, children);
    }
  };
  return /* @__PURE__ */ React__default["default"].createElement(StyledButton, __spreadValues$s({
    className: "pds-Button-root",
    css: button_css
  }, otherProps), iconLeft && iconLeft, renderChildren(), iconRight && iconRight);
};
Button.defaultProps = {
  color: "brandNeutral600",
  labelSpacing: "3",
  size: "md",
  textVariant: "buttonLabel-default",
  variant: "filled"
};

var __defProp$r = Object.defineProperty;
var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
var __hasOwnProp$s = Object.prototype.hasOwnProperty;
var __propIsEnum$s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$r = (obj, key, value) => key in obj ? __defProp$r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$s.call(b, prop))
      __defNormalProp$r(a, prop, b[prop]);
  if (__getOwnPropSymbols$s)
    for (var prop of __getOwnPropSymbols$s(b)) {
      if (__propIsEnum$s.call(b, prop))
        __defNormalProp$r(a, prop, b[prop]);
    }
  return a;
};
const Ol = PrensaEngine.styled("ol", {});
const Li = PrensaEngine.styled("li", {});
function parseMonthToLocale(d) {
  switch (d) {
    case 0:
      return "Janeiro";
    case 1:
      return "Fevereiro";
    case 2:
      return "Mar\xE7o";
    case 3:
      return "Abril";
    case 4:
      return "Maio";
    case 5:
      return "Junho";
    case 6:
      return "Julho";
    case 7:
      return "Agosto";
    case 8:
      return "Setembro";
    case 9:
      return "Outubro";
    case 10:
      return "Novembro";
    case 11:
      return "Dezembro";
  }
}
function getAllDaysInMonth(year, month) {
  const date = new Date(year, month, 1);
  const dates = [];
  while (date.getMonth() === month) {
    dates.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  return dates;
}
function calculateDaysElements(daysOfMonth, daysOfLastMonth, firstDayGap) {
  const dayElements = [...daysOfMonth];
  if (firstDayGap > 0) {
    let lastMonthGapDays = [];
    let i = firstDayGap;
    while (i > 0) {
      lastMonthGapDays.push(daysOfLastMonth[daysOfLastMonth.length - i]);
      i = i - 1;
    }
    lastMonthGapDays.reverse().forEach((i2) => dayElements.unshift(i2));
  }
  return dayElements;
}
function calculateDatesForPicker(d) {
  const date = new Date(d);
  const month = date.getMonth();
  const year = date.getFullYear();
  const daysOfLastMonth = getAllDaysInMonth(month === 0 ? year - 1 : year, month === 0 ? 11 : month - 1);
  const daysOfMonth = getAllDaysInMonth(year, month);
  const daysOfNextMonth = getAllDaysInMonth(month === 11 ? year + 1 : year, month === 11 ? 0 : month + 1);
  const firstDayOfMonth = daysOfMonth[0];
  const lastDayOfMonth = daysOfMonth[daysOfMonth.length - 1];
  const firstDayGap = firstDayOfMonth.getDay();
  const lastDayGap = lastDayOfMonth.getDay();
  const renderDays = calculateDaysElements(daysOfMonth, daysOfLastMonth, firstDayGap);
  return {
    date,
    month,
    year,
    daysOfLastMonth,
    daysOfMonth,
    daysOfNextMonth,
    firstDayGap,
    lastDayGap,
    renderDays
  };
}
const LOCALE_DAYS_OF_WEEK = ["D", "S", "T", "Q", "Q", "S", "S"];
const Calendar = ({ css, date, selectedDate, onChange, icBackward, icForward }) => {
  const rendertime = Date.now();
  const dates = calculateDatesForPicker(date ? date : rendertime);
  const [state, setState] = React.useState(dates);
  const handleChange = (e, d) => {
    onChange(d);
  };
  const renderHeader = () => {
    const handlePrev = () => {
      const newState = calculateDatesForPicker(state.daysOfLastMonth[state.daysOfLastMonth.length - 1]);
      setState(__spreadValues$r({}, newState));
    };
    const handleNext = () => {
      const newState = calculateDatesForPicker(state.daysOfNextMonth[state.daysOfNextMonth.length - 1]);
      setState(__spreadValues$r({}, newState));
    };
    return /* @__PURE__ */ React__default["default"].createElement(Block, {
      as: "header",
      className: "pds-Calendar-headerGroup",
      css: __spreadValues$r({
        align: ["row", "between", "middle"],
        width: "100%"
      }, css == null ? void 0 : css.headerGroup)
    }, /* @__PURE__ */ React__default["default"].createElement(IconButton, {
      className: "pds-Calendar-headerButton",
      variant: "ghost",
      css: {
        button: __spreadValues$r({
          align: ["row", "center", "middle"],
          borderRadius: "$circle",
          height: "$11",
          width: "$11"
        }, css == null ? void 0 : css.headerButton)
      },
      onClick: handlePrev
    }, icBackward ? icBackward : "<"), /* @__PURE__ */ React__default["default"].createElement(Typography, {
      as: "span",
      className: "pds-Calendar-headerTitle",
      css: __spreadValues$r({
        fontFamily: "$primary"
      }, css == null ? void 0 : css.headerTitle)
    }, parseMonthToLocale(state.month), " de ", state.year), /* @__PURE__ */ React__default["default"].createElement(IconButton, {
      className: "pds-Calendar-headerButton",
      variant: "ghost",
      css: {
        button: __spreadValues$r({
          align: ["row", "center", "middle"],
          borderRadius: "$circle",
          height: "$11",
          width: "$11"
        }, css == null ? void 0 : css.headerButton)
      },
      onClick: handleNext
    }, icForward ? icForward : ">"));
  };
  const renderDaysOfWeek = () => {
    return /* @__PURE__ */ React__default["default"].createElement(Block, {
      className: "pds-Calendar-weekGroup",
      css: __spreadValues$r({
        align: ["row", "between", "middle"]
      }, css == null ? void 0 : css.weekGroup)
    }, LOCALE_DAYS_OF_WEEK.map((d, k) => /* @__PURE__ */ React__default["default"].createElement(Typography, {
      as: "span",
      className: "pds-Calendar-weekDay",
      key: `${d}-${k}`,
      css: __spreadValues$r({
        align: ["row", "center", "middle"],
        height: "39px",
        width: "39px",
        fontFamily: "$primary"
      }, css == null ? void 0 : css.weekDay)
    }, d)));
  };
  const renderDays = () => {
    return /* @__PURE__ */ React__default["default"].createElement(Ol, {
      className: "pds-Calendar-dayGroup",
      css: __spreadValues$r({
        align: ["row", "left", "top"],
        flexWrap: "wrap",
        padding: "0px",
        maxWidth: "calc(273px + $8)",
        mt: "$0",
        mb: "$4",
        "list-style-type": "none"
      }, css == null ? void 0 : css.dayGroup)
    }, state.renderDays.map((d) => {
      return /* @__PURE__ */ React__default["default"].createElement(Li, {
        className: "pds-Calendar-day",
        key: d.getTime(),
        css: __spreadValues$r({
          align: ["row", "center", "middle"],
          height: "39px",
          width: "39px"
        }, css == null ? void 0 : css.day)
      }, /* @__PURE__ */ React__default["default"].createElement(IconButton, {
        className: "pds-Calendar-dayButton",
        variant: "ghost",
        "data-selected-state": d === selectedDate,
        disabled: d.getMonth() !== state.month,
        onClick: (e) => handleChange(e, d),
        css: {
          button: __spreadValues$r({
            borderRadius: "$circle",
            color: "$brandNeutral800",
            "&[data-selected-state=true]": {
              backgroundColor: "$brandPrimary400"
            },
            "&:hover": {
              backgroundColor: "$basicBlackAlpha300"
            },
            "&:active": {
              backgroundColor: "$basicBlackAlpha400"
            },
            "&:disabled": {
              backgroundColor: "none",
              color: "$brandNeutral400",
              "&:hover": {
                backgroundColor: "unset",
                cursor: "not-allowed"
              }
            }
          }, css == null ? void 0 : css.dayButton)
        }
      }, d.getDate()));
    }));
  };
  return /* @__PURE__ */ React__default["default"].createElement(Block, {
    className: "pds-Calendar-container",
    css: __spreadValues$r({
      align: ["column", "center", "top"],
      borderColor: "$basicBlackAlpha500",
      borderStyle: "solid",
      borderWidth: "1px",
      borderRadius: "calc($alternative * 3)",
      p: "$4",
      maxWidth: "273px"
    }, css == null ? void 0 : css.container)
  }, renderHeader(), renderDaysOfWeek(), renderDays());
};

var __defProp$q = Object.defineProperty;
var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
var __hasOwnProp$r = Object.prototype.hasOwnProperty;
var __propIsEnum$r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$q = (obj, key, value) => key in obj ? __defProp$q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$r.call(b, prop))
      __defNormalProp$q(a, prop, b[prop]);
  if (__getOwnPropSymbols$r)
    for (var prop of __getOwnPropSymbols$r(b)) {
      if (__propIsEnum$r.call(b, prop))
        __defNormalProp$q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$r)
    for (var prop of __getOwnPropSymbols$r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Carousel = (_a) => {
  var _b = _a, {
    css,
    centerSlidePercentage,
    children,
    height,
    width
  } = _b, otherProps = __objRest$5(_b, [
    "css",
    "centerSlidePercentage",
    "children",
    "height",
    "width"
  ]);
  const styles = __spreadValues$q({
    height,
    width,
    ".carousel-root": __spreadValues$q({
      outline: "none",
      height
    }, css == null ? void 0 : css.root),
    ".carousel .slider": __spreadValues$q({
      margin: "0",
      padding: "0",
      position: "relative",
      listStyle: "none",
      height,
      width: "100%"
    }, css == null ? void 0 : css.slider),
    ".carousel .slide": __spreadValues$q({
      align: ["row", "center", "middle"],
      minWidth: centerSlidePercentage ? `${centerSlidePercentage}%` : "100%",
      margin: "0",
      position: "relative",
      textAlign: "center"
    }, css == null ? void 0 : css.slide),
    ".carousel .control-dots": __spreadValues$q({
      position: "absolute",
      bottom: "0",
      margin: "10px 0",
      padding: "0",
      textAlign: "center",
      width: "100%",
      zIndex: 1
    }, css == null ? void 0 : css.controlDots),
    ".carousel .control-dots .dot": __spreadValues$q({
      WebkitTransition: "opacity 0.25s ease-in",
      MozTransition: "opacity 0.25s ease-in",
      msTransition: "opacity 0.25s ease-in",
      OTransition: "opacity 0.25s ease-in",
      transition: "opacity 0.25s ease-in",
      opacity: 0.3,
      filter: "alpha(opacity=30)",
      boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.9)",
      background: "#fff",
      borderRadius: "50%",
      width: "8px",
      height: "8px",
      cursor: "pointer",
      display: "inline-block",
      margin: "0 8px"
    }, css == null ? void 0 : css.controlDotsDot),
    ".carousel": __spreadValues$q({
      position: "relative",
      width: "100%"
    }, css == null ? void 0 : css.carousel),
    ".carousel .thumbs-wrapper": __spreadValues$q({
      margin: "20px",
      overflow: "hidden"
    }, css == null ? void 0 : css.sliderThumbsWrapper),
    ".carousel .thumbs": __spreadValues$q({
      align: ["row", "left", "middle"],
      paddingLeft: "0px",
      WebkitTransition: "all 0.15s ease-in",
      MozTransition: "all 0.15s ease-in",
      msTransition: "all 0.15s ease-in",
      OTransition: "all 0.15s ease-in",
      transition: "all 0.15s ease-in",
      WebkitTransform: "translate3d(0, 0, 0)",
      MozTransform: "translate3d(0, 0, 0)",
      msTransform: "translate3d(0, 0, 0)",
      OTransform: "translate3d(0, 0, 0)",
      transform: "translate3d(0, 0, 0)",
      position: "relative",
      listStyle: "none",
      whiteSpace: "nowrap"
    }, css == null ? void 0 : css.sliderThumbsAnimated),
    ".carousel.carousel-slider .control-arrow": __spreadValues$q({
      WebkitTransition: "all 0.25s ease-in",
      MozTransition: "all 0.25s ease-in",
      msTransition: "all 0.25s ease-in",
      OTransition: "all 0.25s ease-in",
      transition: "all 0.25s ease-in",
      opacity: 0.4,
      filter: "alpha(opacity=40)",
      position: "absolute",
      zIndex: 2,
      border: "0",
      fontSize: "32px",
      cursor: "pointer",
      outline: "0",
      top: "50%"
    }, css == null ? void 0 : css.controlArrow),
    ".carousel .control-arrow:hover": {
      opacity: 1,
      filter: "alpha(opacity=100)"
    },
    ".carousel .control-arrow:focus": {
      opacity: 1,
      filter: "alpha(opacity=100)"
    },
    ".carousel.carousel-slider .control-arrow:before": {
      margin: "0 5px",
      display: "inline-block",
      borderTop: "8px solid transparent",
      borderBottom: "8px solid transparent",
      content: ""
    },
    ".carousel .control-arrow:before": {
      margin: "0 5px",
      display: "inline-block",
      borderTop: "8px solid transparent",
      borderBottom: "8px solid transparent",
      content: ""
    },
    ".carousel .control-disabled.control-arrow": {
      opacity: 0,
      filter: "alpha(opacity=0)",
      cursor: "inherit",
      display: "none"
    },
    ".carousel .control-prev.control-arrow": {
      left: "0"
    },
    ".carousel .control-prev.control-arrow:before": {
      borderRight: "8px solid #fff"
    },
    ".carousel .control-next.control-arrow": {
      right: "0"
    },
    ".carousel .control-next.control-arrow:before": {
      borderLeft: "8px solid #fff"
    },
    ".carousel *": {
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box"
    },
    ".carousel img": {
      width: "100%",
      display: "inline-block",
      pointerEvents: "none"
    },
    ".carousel .carousel": {
      position: "relative"
    },
    ".carousel .thumb": {
      WebkitTransition: "border 0.15s ease-in",
      MozTransition: "border 0.15s ease-in",
      msTransition: "border 0.15s ease-in",
      OTransition: "border 0.15s ease-in",
      transition: "border 0.15s ease-in",
      display: "inline-block",
      marginRight: "6px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      border: "3px solid #fff",
      padding: "2px",
      height: "48px",
      width: "48px"
    },
    ".carousel .thumb:focus": { border: "3px solid #ccc", outline: "none" },
    ".carousel .thumb:hover": {
      border: "3px solid #333"
    },
    ".carousel .thumb.selected": {
      border: "3px solid #333"
    },
    ".carousel .thumb img": {
      verticalAlign: "top",
      height: "100%",
      width: "100%"
    },
    ".carousel.carousel-slider": {
      position: "relative",
      margin: "0",
      overflow: "hidden"
    },
    ".carousel.carousel-slider .control-arrow:hover": {
      background: "rgba(0, 0, 0, 0.2)"
    },
    ".carousel .slider-wrapper": {
      overflow: "hidden",
      margin: "auto",
      width: "100%",
      WebkitTransition: "height 0.15s ease-in",
      MozTransition: "height 0.15s ease-in",
      msTransition: "height 0.15s ease-in",
      OTransition: "height 0.15s ease-in",
      transition: "height 0.15s ease-in"
    },
    ".carousel .slider-wrapper.axis-horizontal .slider": {
      msBoxOrient: "horizontal",
      display: "flex"
    },
    ".carousel .slider-wrapper.axis-horizontal .slider .slide": {
      flexDirection: "column",
      flexFlow: "column"
    },
    ".carousel .slider-wrapper.axis-vertical": {
      msBoxOrient: "horizontal",
      display: "flex"
    },
    ".carousel .slider-wrapper.axis-vertical .slider": {
      WebkitFlexDirection: "column",
      flexDirection: "column"
    },
    ".carousel .slider.animated": {
      WebkitTransition: "all 0.35s ease-in-out",
      MozTransition: "all 0.35s ease-in-out",
      msTransition: "all 0.35s ease-in-out",
      OTransition: "all 0.35s ease-in-out",
      transition: "all 0.35s ease-in-out"
    },
    ".carousel .slide img": {
      width: "100%",
      verticalAlign: "top",
      border: "0"
    },
    ".carousel .slide iframe": {
      display: "inline-block",
      width: "calc(100% - 80px)",
      margin: "0 40px 40px",
      border: "0"
    },
    ".carousel .slide .legend": {
      WebkitTransition: ["all 0.5s ease-in-out", "opacity 0.35s ease-in-out"],
      MozTransition: ["all 0.5s ease-in-out", "opacity 0.35s ease-in-out"],
      msTransition: ["all 0.5s ease-in-out", "opacity 0.35s ease-in-out"],
      OTransition: ["all 0.5s ease-in-out", "opacity 0.35s ease-in-out"],
      transition: ["all 0.5s ease-in-out", "opacity 0.35s ease-in-out"],
      position: "absolute",
      bottom: "40px",
      left: "50%",
      marginLeft: "-45%",
      width: "90%",
      borderRadius: "10px",
      background: "#000",
      color: "#fff",
      padding: "10px",
      fontSize: "12px",
      textAlign: "center",
      opacity: 0.25
    },
    "@media (min-width: 960px)": {
      ".carousel .control-dots": {
        bottom: "0"
      }
    },
    ".carousel .control-dots .dot:hover": {
      opacity: 1,
      filter: "alpha(opacity=100)"
    },
    ".carousel .control-dots .dot.selected": {
      opacity: 1,
      filter: "alpha(opacity=100)"
    },
    ".carousel .carousel-status": {
      position: "absolute",
      top: "0",
      right: "0",
      padding: "5px",
      fontSize: "10px",
      textShadow: "1px 1px 1px rgba(0, 0, 0, 0.9)",
      color: "#fff"
    },
    ".carousel:hover .slide .legend": {
      opacity: 1
    }
  }, css == null ? void 0 : css.container);
  return /* @__PURE__ */ React__default["default"].createElement(Block, {
    className: "pds-Carousel-container",
    css: styles
  }, /* @__PURE__ */ React__default["default"].createElement(reactResponsiveCarousel.Carousel, __spreadValues$q({
    showStatus: false,
    showThumbs: false,
    swipeable: true,
    emulateTouch: true,
    centerSlidePercentage
  }, otherProps), children));
};

const Prensa_Drawer_slideInLeft = PrensaEngine.keyframes({
  "0%": { transform: "translateX(-100%)" },
  "100%": { transform: "translateX(0%)" }
});
const Prensa_Drawer_slideOutLeft = PrensaEngine.keyframes({
  "0%": { transform: "translateX(0%)" },
  "100%": { transform: "translateX(-100%)" }
});
const Prensa_Drawer_backdropIn = PrensaEngine.keyframes({
  "0%": { opacity: 0 },
  "100%": { opacity: 1 }
});
const Prensa_Drawer_backdropOut = PrensaEngine.keyframes({
  "0%": { opacity: 1 },
  "100%": { opacity: 0 }
});
const DrawerContainer = PrensaEngine.styled("div", {
  ".pds-Drawer-content[data-open-state=true]": {
    animationName: Prensa_Drawer_slideInLeft,
    animationDuration: "233ms",
    animationFillMode: "forwards",
    animationTimingFunction: "cubic-bezier(0,0,.21,1)"
  },
  ".pds-Drawer-content[hidden]": {
    animationName: Prensa_Drawer_slideOutLeft,
    animationDuration: "300ms",
    animationFillMode: "forwards",
    animationTimingFunction: "cubic-bezier(0,0,.21,1)",
    top: "-8000px",
    transform: "translateX(-100%)",
    transition: "top 0.01s 1s"
  },
  ".pds-Drawer-backdrop[data-open-state=true]": {
    animationName: Prensa_Drawer_backdropIn,
    animationDuration: "233ms",
    animationFillMode: "forwards",
    animationTimingFunction: "cubic-bezier(0,0,.21,1)"
  },
  ".pds-Drawer-backdrop[hidden]": {
    animationName: Prensa_Drawer_backdropOut,
    animationDuration: "300ms",
    animationFillMode: "forwards",
    animationTimingFunction: "cubic-bezier(0,0,.21,1)"
  }
});
const DrawerContent = PrensaEngine.styled("aside", {
  backgroundColor: "$basicWhite",
  display: "block",
  height: "100vh",
  overflowY: "auto",
  position: "fixed",
  zIndex: "$drawer$contentZIndex",
  variants: {
    size: {
      maxcontent: { width: "$drawer$sizeMaxcontent" },
      sm: { width: "$drawer$sizeSm" },
      md: { width: "$drawer$sizeMd" },
      lg: { width: "$drawer$sizeLg" },
      fullwidth: { width: "$drawer$sizeFullwidth" }
    },
    anchor: {
      left: {
        top: "0px",
        left: "0px"
      },
      right: {
        top: "0px",
        right: "0px"
      }
    }
  }
});
const DrawerBackdrop = PrensaEngine.styled("div", {
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  height: "100vh",
  position: "fixed",
  top: "0px",
  left: "0px",
  width: "100vw",
  zIndex: "$drawer$backdropZIndex"
});
const DrawerSpacer = PrensaEngine.styled("div", {
  variants: {
    innerSpace: {
      sm: { padding: "$drawer$innerSpaceSm" },
      md: { padding: "$drawer$innerSpaceMd" },
      lg: { padding: "$drawer$innerSpaceLg" }
    }
  }
});

var __defProp$p = Object.defineProperty;
var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
var __hasOwnProp$q = Object.prototype.hasOwnProperty;
var __propIsEnum$q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$p = (obj, key, value) => key in obj ? __defProp$p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$q.call(b, prop))
      __defNormalProp$p(a, prop, b[prop]);
  if (__getOwnPropSymbols$q)
    for (var prop of __getOwnPropSymbols$q(b)) {
      if (__propIsEnum$q.call(b, prop))
        __defNormalProp$p(a, prop, b[prop]);
    }
  return a;
};
const Drawer = ({
  anchor,
  children,
  close,
  innerSpace,
  open,
  size,
  css
}) => {
  let container_css = {};
  let backdrop_css = {};
  let content_css = {};
  let spacer_css = {};
  if (css) {
    if (css.container) {
      container_css = __spreadValues$p({}, css.container);
    }
    if (css.backdrop) {
      backdrop_css = __spreadValues$p({}, css.backdrop);
    }
    if (css.content) {
      content_css = __spreadValues$p({}, css.content);
    }
    if (css.spacer) {
      spacer_css = __spreadValues$p({}, css.spacer);
    }
  }
  return /* @__PURE__ */ React__default["default"].createElement(DrawerContainer, {
    className: "pds-Drawer-container",
    css: container_css
  }, /* @__PURE__ */ React__default["default"].createElement(DrawerBackdrop, {
    className: "pds-Drawer-backdrop",
    "data-open-state": open,
    hidden: !open,
    onClick: close,
    css: backdrop_css
  }), /* @__PURE__ */ React__default["default"].createElement(DrawerContent, {
    className: "pds-Drawer-content",
    "data-open-state": open,
    hidden: !open,
    anchor,
    size,
    css: content_css
  }, /* @__PURE__ */ React__default["default"].createElement(DrawerSpacer, {
    className: "pds-Drawer-spacer",
    innerSpace,
    css: spacer_css
  }, children)));
};
Drawer.defaultProps = {
  anchor: "left"
};

const Caption = ({
  children
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(Block, {
    css: {
      align: ["row", "left", "middle"],
      pt: "$2",
      px: "$2",
      width: "100%",
      "@lg": {
        pt: "$2",
        px: "$2",
        width: "100%"
      }
    }
  }, /* @__PURE__ */ React__default["default"].createElement(Typography, {
    as: "p"
  }, children));
};
Caption.defaultProps = {};

var __defProp$o = Object.defineProperty;
var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
var __hasOwnProp$p = Object.prototype.hasOwnProperty;
var __propIsEnum$p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$o = (obj, key, value) => key in obj ? __defProp$o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$p.call(b, prop))
      __defNormalProp$o(a, prop, b[prop]);
  if (__getOwnPropSymbols$p)
    for (var prop of __getOwnPropSymbols$p(b)) {
      if (__propIsEnum$p.call(b, prop))
        __defNormalProp$o(a, prop, b[prop]);
    }
  return a;
};
const LeftArrowIcon = (props) => {
  return /* @__PURE__ */ React__default["default"].createElement("svg", __spreadValues$o({
    color: "white",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React__default["default"].createElement("path", {
    d: "M15 8.25H5.87l4.19-4.19L9 3 3 9l6 6 1.06-1.06-4.19-4.19H15v-1.5z"
  }));
};

var __defProp$n = Object.defineProperty;
var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
var __hasOwnProp$o = Object.prototype.hasOwnProperty;
var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$n = (obj, key, value) => key in obj ? __defProp$n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$o.call(b, prop))
      __defNormalProp$n(a, prop, b[prop]);
  if (__getOwnPropSymbols$o)
    for (var prop of __getOwnPropSymbols$o(b)) {
      if (__propIsEnum$o.call(b, prop))
        __defNormalProp$n(a, prop, b[prop]);
    }
  return a;
};
const RightArrowIcon = (props) => {
  return /* @__PURE__ */ React__default["default"].createElement("svg", __spreadValues$n({
    color: "white",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React__default["default"].createElement("path", {
    d: "M9 3 7.94 4.06l4.19 4.19H3v1.5h9.13l-4.19 4.19L9 15l6-6z"
  }));
};

var __defProp$m = Object.defineProperty;
var __defProps$i = Object.defineProperties;
var __getOwnPropDescs$i = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
var __hasOwnProp$n = Object.prototype.hasOwnProperty;
var __propIsEnum$n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$m = (obj, key, value) => key in obj ? __defProp$m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$n.call(b, prop))
      __defNormalProp$m(a, prop, b[prop]);
  if (__getOwnPropSymbols$n)
    for (var prop of __getOwnPropSymbols$n(b)) {
      if (__propIsEnum$n.call(b, prop))
        __defNormalProp$m(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$i = (a, b) => __defProps$i(a, __getOwnPropDescs$i(b));
const buttonProps = {
  align: ["row", "center", "middle"],
  backgroundColor: "white",
  borderColor: "rgba(0,0,0,0.8)",
  borderStyle: "solid",
  borderRadius: "2px",
  borderWidth: "1px",
  border: "unset",
  width: "34px",
  height: "34px",
  margin: "16px",
  position: "absolute",
  top: "calc(50% - 64px)",
  zIndex: "10"
};
const ButtonLeft = PrensaEngine.styled("button", __spreadProps$i(__spreadValues$m({}, buttonProps), {
  left: "0px"
}));
const ButtonRight = PrensaEngine.styled("button", __spreadProps$i(__spreadValues$m({}, buttonProps), {
  right: "0px"
}));

var __defProp$l = Object.defineProperty;
var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
var __hasOwnProp$m = Object.prototype.hasOwnProperty;
var __propIsEnum$m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$m.call(b, prop))
      __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$m)
    for (var prop of __getOwnPropSymbols$m(b)) {
      if (__propIsEnum$m.call(b, prop))
        __defNormalProp$l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$m)
    for (var prop of __getOwnPropSymbols$m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ControlButton = (_a) => {
  var _b = _a, {
    isNext,
    onClick
  } = _b, otherProps = __objRest$4(_b, [
    "isNext",
    "onClick"
  ]);
  const renderIcon = () => {
    if (isNext)
      return /* @__PURE__ */ React__default["default"].createElement(RightArrowIcon, null);
    return /* @__PURE__ */ React__default["default"].createElement(LeftArrowIcon, null);
  };
  const ButtonElement = isNext ? ButtonRight : ButtonLeft;
  return /* @__PURE__ */ React__default["default"].createElement(ButtonElement, __spreadValues$l({
    type: "button",
    "aria-label": isNext ? "Avan\xE7ar" : "Retroceder",
    onClick
  }, otherProps), renderIcon());
};

var __defProp$k = Object.defineProperty;
var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
var __hasOwnProp$l = Object.prototype.hasOwnProperty;
var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$l.call(b, prop))
      __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$l)
    for (var prop of __getOwnPropSymbols$l(b)) {
      if (__propIsEnum$l.call(b, prop))
        __defNormalProp$k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$l)
    for (var prop of __getOwnPropSymbols$l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ImageGallery = (_a) => {
  var _b = _a, {
    captionProps,
    componentCaption,
    componentImage,
    items
  } = _b, otherProps = __objRest$3(_b, [
    "captionProps",
    "componentCaption",
    "componentImage",
    "items"
  ]);
  const RenderCaption = componentCaption;
  const RenderImage = componentImage;
  const renderArrowPrev = (onClick, hasArrow) => {
    return hasArrow && /* @__PURE__ */ React__default["default"].createElement(ControlButton, {
      onClick
    });
  };
  const renderArrowNext = (onClick, hasArrow) => {
    return hasArrow && /* @__PURE__ */ React__default["default"].createElement(ControlButton, {
      onClick,
      isNext: true
    });
  };
  const renderCaptionOriginalOrCustom = (item) => {
    if (captionProps.enabled && RenderCaption) {
      return /* @__PURE__ */ React__default["default"].createElement(RenderCaption, {
        captionProps,
        textValue: item.caption
      });
    } else {
      return /* @__PURE__ */ React__default["default"].createElement(Caption, __spreadValues$k({}, captionProps), item.caption);
    }
  };
  return /* @__PURE__ */ React__default["default"].createElement(Carousel, __spreadValues$k({
    axis: "horizontal",
    labels: { item: "", leftArrow: "Retroceder", rightArrow: "Avan\xE7ar" },
    showIndicators: false,
    showStatus: false,
    showThumbs: false,
    renderArrowPrev,
    renderArrowNext
  }, otherProps), items.map((item, key) => /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, {
    key: `slide${key}`
  }, componentImage ? /* @__PURE__ */ React__default["default"].createElement(RenderImage, {
    alt: item == null ? void 0 : item.caption,
    src: item == null ? void 0 : item.url
  }) : /* @__PURE__ */ React__default["default"].createElement("img", {
    alt: item == null ? void 0 : item.caption,
    src: item == null ? void 0 : item.url
  }), renderCaptionOriginalOrCustom(item))));
};

var __defProp$j = Object.defineProperty;
var __defProps$h = Object.defineProperties;
var __getOwnPropDescs$h = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
var __hasOwnProp$k = Object.prototype.hasOwnProperty;
var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$k.call(b, prop))
      __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$k)
    for (var prop of __getOwnPropSymbols$k(b)) {
      if (__propIsEnum$k.call(b, prop))
        __defNormalProp$j(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$h = (a, b) => __defProps$h(a, __getOwnPropDescs$h(b));
const Tabs = (props) => {
  var _a;
  const [selectedTab, setSelectedTab] = React.useState(`${props.id}-tab0`);
  return /* @__PURE__ */ React__default["default"].createElement(Block, {
    className: "pds-Tabs-container",
    css: (_a = props.css) == null ? void 0 : _a.container
  }, React__default["default"].Children.map(props.children, (c) => __spreadProps$h(__spreadValues$j({}, c), {
    props: __spreadProps$h(__spreadValues$j({}, c.props), {
      selected: selectedTab,
      setSelected: setSelectedTab,
      "data-tabs-id": props.id,
      css: props.css
    })
  })));
};

var __defProp$i = Object.defineProperty;
var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$j.call(b, prop))
      __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(b)) {
      if (__propIsEnum$j.call(b, prop))
        __defNormalProp$i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function useComponentFromProps(_a, children = null) {
  var _b = _a, {
    bypass = false,
    component,
    componentProps
  } = _b, rest = __objRest$2(_b, [
    "bypass",
    "component",
    "componentProps"
  ]);
  const CustomComponent = component;
  const isReactElement = React.isValidElement(CustomComponent);
  if (bypass === true) {
    return children;
  }
  if (isReactElement) {
    return React.cloneElement(CustomComponent, componentProps, children);
  }
  if (typeof CustomComponent === "function") {
    return /* @__PURE__ */ React__default["default"].createElement(CustomComponent, __spreadValues$i(__spreadValues$i({}, rest), componentProps), children);
  }
}

const Footer$1 = PrensaEngine.styled("footer", {});

const Footer = ({
  css,
  slotTop,
  slotTopProps,
  slotMiddle,
  slotMiddleProps,
  slotBottom,
  slotBottomProps
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(Footer$1, {
    css: css == null ? void 0 : css.containerCss
  }, slotTop && /* @__PURE__ */ React__default["default"].createElement(Block, {
    css: css == null ? void 0 : css.slotTopCss
  }, useComponentFromProps({
    component: slotTop,
    componentProps: slotTopProps
  })), /* @__PURE__ */ React__default["default"].createElement(Block, {
    css: css == null ? void 0 : css.slotMiddleCss
  }, useComponentFromProps({
    component: slotMiddle,
    componentProps: slotMiddleProps
  })), slotBottom && /* @__PURE__ */ React__default["default"].createElement(Block, {
    css: css == null ? void 0 : css.slotBottomCss
  }, useComponentFromProps({
    component: slotBottom,
    componentProps: slotBottomProps
  })));
};

var __defProp$h = Object.defineProperty;
var __defProps$g = Object.defineProperties;
var __getOwnPropDescs$g = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$i.call(b, prop))
      __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(b)) {
      if (__propIsEnum$i.call(b, prop))
        __defNormalProp$h(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$g = (a, b) => __defProps$g(a, __getOwnPropDescs$g(b));
const Column$1 = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$g(__spreadValues$h({}, customProps), {
  className: `Column ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$h(__spreadValues$h({}, defaultCss), css)
}), children);
Column$1.defaultProps = {
  defaultCss: {
    align: ["column", "center", "top"],
    width: "100%",
    ".desktop": {
      display: "none",
      "@lg": {
        display: "flex"
      }
    },
    ".mobile": {
      "@lg": {
        display: "none"
      }
    }
  }
};
const ColumnTop = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$g(__spreadValues$h({}, customProps), {
  className: `ColumnTop ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$h(__spreadValues$h({}, defaultCss), css)
}), children);
ColumnTop.defaultProps = {
  defaultCss: {
    width: "100%"
  }
};
const ColumnContent = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$g(__spreadValues$h({}, customProps), {
  className: `ColumnContent ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$h(__spreadValues$h({}, defaultCss), css)
}), children);
ColumnContent.defaultProps = {
  defaultCss: {
    width: "100%"
  }
};
const ColumnBottom = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$g(__spreadValues$h({}, customProps), {
  className: `ColumnBottom ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$h(__spreadValues$h({}, defaultCss), css)
}), children);
ColumnBottom.defaultProps = {
  defaultCss: {
    width: "100%"
  }
};
const ColumnHolder = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$g(__spreadValues$h({}, customProps), {
  className: `ColumnHolder ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$h(__spreadValues$h({}, defaultCss), css)
}), children);
ColumnHolder.defaultProps = {
  defaultCss: {
    align: ["column", "center", "middle"],
    width: "100%"
  }
};

var __defProp$g = Object.defineProperty;
var __defProps$f = Object.defineProperties;
var __getOwnPropDescs$f = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$h.call(b, prop))
      __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(b)) {
      if (__propIsEnum$h.call(b, prop))
        __defNormalProp$g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$f = (a, b) => __defProps$f(a, __getOwnPropDescs$f(b));
const Column = ({
  css,
  customProps,
  color,
  items,
  itemsBottom,
  itemsTop,
  itemComponent,
  layout,
  name,
  wrapperTop = { enabled: false, component: null },
  wrapperContent = { enabled: false, component: null },
  wrapperBottom = { enabled: false, component: null }
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const Item = itemComponent;
  const columnProps = {
    css: __spreadValues$g(__spreadValues$g({}, css == null ? void 0 : css.column), (_a = layout == null ? void 0 : layout.css) == null ? void 0 : _a.column),
    customProps: __spreadProps$f(__spreadValues$g(__spreadValues$g({}, customProps == null ? void 0 : customProps.column), (_b = layout == null ? void 0 : layout.customProps) == null ? void 0 : _b.column), {
      className: `Column ${name || ""}
        ${((_d = (_c = layout == null ? void 0 : layout.customProps) == null ? void 0 : _c.column) == null ? void 0 : _d.className) || ""}
        ${((_e = customProps == null ? void 0 : customProps.column) == null ? void 0 : _e.className) || ""}
      `
    })
  };
  const columnGroupProps = {
    css: __spreadValues$g(__spreadValues$g({}, css == null ? void 0 : css.column), (_f = layout == null ? void 0 : layout.css) == null ? void 0 : _f.column),
    customProps: __spreadValues$g(__spreadValues$g({}, customProps == null ? void 0 : customProps.column), (_g = layout == null ? void 0 : layout.customProps) == null ? void 0 : _g.column)
  };
  const getColumnItemLayout = ({ layout: layout2, position, size }) => {
    const defaultLayout = lodash.get(layout2, "default");
    const defaultBySize = lodash.get(layout2, `[${size}]`);
    const defaultByNumber = lodash.get(layout2, `[${size}:${position + 1}]`);
    return defaultByNumber || defaultBySize || defaultLayout;
  };
  const renderItem = ({ item, position }) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h;
    const itemLayout = getColumnItemLayout({
      layout,
      position,
      size: items ? items.length : 0
    });
    const itemMobile = lodash.get(itemLayout, [0]);
    const itemDesktop = lodash.get(itemLayout, [1]);
    const itemMobileProps = __spreadProps$f(__spreadValues$g(__spreadValues$g({}, itemMobile), item), {
      css: __spreadValues$g(__spreadValues$g(__spreadValues$g({}, css == null ? void 0 : css.item), (_a2 = layout == null ? void 0 : layout.css) == null ? void 0 : _a2.item), itemMobile == null ? void 0 : itemMobile.css),
      customProps: __spreadProps$f(__spreadValues$g(__spreadValues$g({}, customProps == null ? void 0 : customProps.item), item == null ? void 0 : item.customProps), {
        className: `
          ${((_b2 = customProps == null ? void 0 : customProps.item) == null ? void 0 : _b2.className) || ""}
          ${((_d2 = (_c2 = layout == null ? void 0 : layout.customProps) == null ? void 0 : _c2.item) == null ? void 0 : _d2.className) || ""}
          mobile
        `
      }),
      numberValue: (position + 1).toString(),
      slotColor: color,
      slotName: name
    });
    const itemDesktopProps = __spreadProps$f(__spreadValues$g(__spreadValues$g({}, itemDesktop), item), {
      css: __spreadValues$g(__spreadValues$g(__spreadValues$g({}, css == null ? void 0 : css.item), (_e2 = layout == null ? void 0 : layout.css) == null ? void 0 : _e2.item), itemDesktop == null ? void 0 : itemDesktop.css),
      customProps: __spreadProps$f(__spreadValues$g(__spreadValues$g({}, customProps == null ? void 0 : customProps.item), item == null ? void 0 : item.customProps), {
        className: `
          ${((_f2 = customProps == null ? void 0 : customProps.item) == null ? void 0 : _f2.className) || ""}
          ${((_h = (_g2 = layout == null ? void 0 : layout.customProps) == null ? void 0 : _g2.item) == null ? void 0 : _h.className) || ""}
          desktop
        `
      }),
      numberValue: (position + 1).toString(),
      slotColor: color,
      slotName: name
    });
    return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, {
      key: position
    }, /* @__PURE__ */ React__default["default"].createElement(Item, __spreadValues$g({}, itemMobileProps)), /* @__PURE__ */ React__default["default"].createElement(Item, __spreadValues$g({}, itemDesktopProps)));
  };
  const columnTop = lodash.map(itemsTop, (item, position) => renderItem({ item, position }));
  const columnContent = lodash.map(items, (item, position) => renderItem({ item, position }));
  const columnBottom = lodash.map(itemsBottom, (item, position) => renderItem({ item, position }));
  const renderWrapper = (d, p) => d.component ? d.component(p, renderItem) : p;
  return /* @__PURE__ */ React__default["default"].createElement(Column$1, __spreadValues$g({}, columnProps), /* @__PURE__ */ React__default["default"].createElement(ColumnTop, __spreadValues$g({}, columnGroupProps), wrapperTop.enabled ? renderWrapper(wrapperTop, columnTop) : columnTop), /* @__PURE__ */ React__default["default"].createElement(ColumnContent, __spreadValues$g({}, columnGroupProps), wrapperContent.enabled ? renderWrapper(wrapperContent, columnContent) : columnContent), /* @__PURE__ */ React__default["default"].createElement(ColumnBottom, __spreadValues$g({}, columnGroupProps), wrapperBottom.enabled ? renderWrapper(wrapperBottom, columnBottom) : columnBottom));
};

var __defProp$f = Object.defineProperty;
var __defProps$e = Object.defineProperties;
var __getOwnPropDescs$e = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$g.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(b)) {
      if (__propIsEnum$g.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$e = (a, b) => __defProps$e(a, __getOwnPropDescs$e(b));
const PageBlockContainer = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$e(__spreadValues$f({}, customProps), {
  className: `PageBlock ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$f(__spreadValues$f({}, defaultCss), css)
}), children);
PageBlockContainer.defaultProps = {
  defaultCss: {
    align: ["column", "center", "middle"],
    mb: "$4",
    width: "100%"
  }
};

var __defProp$e = Object.defineProperty;
var __defProps$d = Object.defineProperties;
var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(b)) {
      if (__propIsEnum$f.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$d = (a, b) => __defProps$d(a, __getOwnPropDescs$d(b));
const ItemLabel = ({
  css,
  children,
  customProps,
  defaultCss,
  variants
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(Typography, __spreadProps$d(__spreadValues$e({}, customProps), {
    className: `ItemLabel ${(customProps == null ? void 0 : customProps.className) || ""}`,
    css: __spreadValues$e(__spreadValues$e({}, defaultCss), css),
    variant: lodash.isArray(variants) ? { "@initial": lodash.first(variants), "@lg": lodash.last(variants) } : variants
  }), children);
};
ItemLabel.defaultProps = {
  defaultCss: {
    align: ["column", "center", "middle"]
  },
  variants: ["menuTag-default", "menuTag-desktop"]
};
const ItemStyled = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$d(__spreadValues$e({}, customProps), {
  className: `Item ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$e(__spreadValues$e({}, defaultCss), css)
}), children);
ItemStyled.defaultProps = {
  defaultCss: {
    align: ["column", "center", "middle"],
    width: "100%"
  }
};

const Item = ({
  children,
  customProps,
  css,
  name,
  path
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(ItemStyled, {
    css,
    customProps
  }, children || /* @__PURE__ */ React__default["default"].createElement("a", {
    href: path
  }, /* @__PURE__ */ React__default["default"].createElement(ItemLabel, null, name)));
};

var __defProp$d = Object.defineProperty;
var __defProps$c = Object.defineProperties;
var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$c = (a, b) => __defProps$c(a, __getOwnPropDescs$c(b));
const PageBlock = ({
  css,
  customProps,
  itemComponent,
  slotAutoLeftElements,
  slotAutoCenterElements,
  slotAutoRightElements,
  slotManualTopLeft,
  slotManualTopCenter,
  slotManualTopRight,
  slotManualBottomLeft,
  slotManualBottomCenter,
  slotManualBottomRight,
  slotManualExtra,
  slotManualExtraTop,
  slotLeftBgColor,
  slotLeftColor,
  slotLeftLayout,
  slotCenterBgColor,
  slotCenterColor,
  slotCenterLayout,
  slotRightBgColor,
  slotRightColor,
  slotRightLayout,
  slotLayouts,
  slotTemplate,
  templates,
  templateBgColor,
  wrappers
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R;
  const getWrapperComponent = (wrapperFromProps, wrapperFromTemplate) => {
    const wrapperTemplateEnabled = lodash.get(wrapperFromTemplate, "enabled", false);
    const wrapperPropsEnabled = lodash.get(wrapperFromProps, "enabled", false);
    if (wrapperTemplateEnabled) {
      return wrapperFromTemplate;
    } else if (wrapperPropsEnabled) {
      return wrapperFromProps;
    } else {
      return void 0;
    }
  };
  const getLayoutBySlotAndTemplate = (name, slot) => {
    const layoutSelected = lodash.get(slotLayouts, slot);
    const layoutSlotConfig = lodash.get(layoutSelected, `slotConfig[${slotTemplate}][slot${name}]`);
    return __spreadProps$c(__spreadValues$d({
      css: layoutSelected == null ? void 0 : layoutSelected.css
    }, layoutSlotConfig), {
      wrapperTop: layoutSelected == null ? void 0 : layoutSelected.wrapperTop,
      wrapperContent: layoutSelected == null ? void 0 : layoutSelected.wrapperContent,
      wrapperBottom: layoutSelected == null ? void 0 : layoutSelected.wrapperBottom
    });
  };
  const leftColumnLayout = getLayoutBySlotAndTemplate("Left", slotLeftLayout);
  const centerColumnLayout = getLayoutBySlotAndTemplate("Center", slotCenterLayout);
  const rightColumnLayout = getLayoutBySlotAndTemplate("Right", slotRightLayout);
  const template = lodash.get(templates, slotTemplate || "");
  const templateBgColorValue = templateBgColor ? { backgroundColor: `$${templateBgColor}` } : {};
  const slotLeftBgColorValue = slotLeftBgColor ? { backgroundColor: `$${slotLeftBgColor}` } : {};
  const slotCenterBgColorValue = slotCenterBgColor ? { backgroundColor: `$${slotCenterBgColor}` } : {};
  const slotRightBgColorValue = slotRightBgColor ? { backgroundColor: `$${slotRightBgColor}` } : {};
  const containerCss = __spreadValues$d(__spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.container), (_a = template == null ? void 0 : template.css) == null ? void 0 : _a.container), templateBgColorValue);
  const containerProps = {
    customProps: __spreadProps$c(__spreadValues$d(__spreadValues$d({}, customProps == null ? void 0 : customProps.container), (_b = template == null ? void 0 : template.customProps) == null ? void 0 : _b.container), {
      className: `
        ${((_c = customProps == null ? void 0 : customProps.container) == null ? void 0 : _c.className) || ""}
        ${((_e = (_d = template == null ? void 0 : template.customProps) == null ? void 0 : _d.container) == null ? void 0 : _e.className) || ""}
      `
    }),
    css: containerCss
  };
  const columnHolderCss = __spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.columnHolder), (_f = template == null ? void 0 : template.css) == null ? void 0 : _f.columnHolder);
  const columnHolderProps = {
    customProps: __spreadProps$c(__spreadValues$d(__spreadValues$d({}, customProps == null ? void 0 : customProps.columnHolder), (_g = template == null ? void 0 : template.customProps) == null ? void 0 : _g.columnHolder), {
      className: `
        ${((_h = customProps == null ? void 0 : customProps.columnHolder) == null ? void 0 : _h.className) || ""}
        ${((_j = (_i = template == null ? void 0 : template.customProps) == null ? void 0 : _i.columnHolder) == null ? void 0 : _j.className) || ""}
      `
    }),
    css: columnHolderCss
  };
  const columnProps = {
    customProps: {
      column: __spreadProps$c(__spreadValues$d(__spreadValues$d({}, customProps == null ? void 0 : customProps.column), (_k = template == null ? void 0 : template.customProps) == null ? void 0 : _k.column), {
        className: `
          ${((_l = customProps == null ? void 0 : customProps.column) == null ? void 0 : _l.className) || ""}
          ${((_n = (_m = template == null ? void 0 : template.customProps) == null ? void 0 : _m.column) == null ? void 0 : _n.className) || ""}
        `
      }),
      item: __spreadProps$c(__spreadValues$d(__spreadValues$d({}, customProps == null ? void 0 : customProps.item), (_o = template == null ? void 0 : template.customProps) == null ? void 0 : _o.item), {
        className: `
          ${((_p = customProps == null ? void 0 : customProps.item) == null ? void 0 : _p.className) || ""}
          ${((_r = (_q = template == null ? void 0 : template.customProps) == null ? void 0 : _q.item) == null ? void 0 : _r.className) || ""}
        `
      })
    },
    itemComponent
  };
  const columnExtraTopProps = __spreadProps$c(__spreadValues$d({}, columnProps), {
    css: {
      column: __spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.column), (_s = template == null ? void 0 : template.css) == null ? void 0 : _s.column),
      item: __spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.item), (_t = template == null ? void 0 : template.css) == null ? void 0 : _t.item)
    },
    items: slotManualExtraTop,
    name: "ExtraTop",
    wrapperTop: getWrapperComponent((_u = wrappers == null ? void 0 : wrappers.columnExtraTop) == null ? void 0 : _u.slotTop, leftColumnLayout.wrapperTop),
    wrapperContent: getWrapperComponent((_v = wrappers == null ? void 0 : wrappers.columnExtraTop) == null ? void 0 : _v.slotMiddle, leftColumnLayout.wrapperContent),
    wrapperBottom: getWrapperComponent((_w = wrappers == null ? void 0 : wrappers.columnExtraTop) == null ? void 0 : _w.slotBottom, leftColumnLayout.wrapperBottom)
  });
  const columnLeftProps = __spreadProps$c(__spreadValues$d({}, columnProps), {
    customProps: __spreadProps$c(__spreadValues$d({}, columnProps == null ? void 0 : columnProps.customProps), {
      item: __spreadValues$d({}, (_x = columnProps == null ? void 0 : columnProps.customProps) == null ? void 0 : _x.item)
    }),
    css: {
      column: __spreadValues$d(__spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.column), (_y = template == null ? void 0 : template.css) == null ? void 0 : _y.column), slotLeftBgColorValue),
      item: __spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.item), (_z = template == null ? void 0 : template.css) == null ? void 0 : _z.item)
    },
    color: slotLeftColor,
    items: slotAutoLeftElements,
    itemsBottom: slotManualBottomLeft,
    itemsTop: slotManualTopLeft,
    layout: leftColumnLayout,
    name: "Left",
    wrapperTop: getWrapperComponent((_A = wrappers == null ? void 0 : wrappers.columnLeft) == null ? void 0 : _A.slotTop, leftColumnLayout.wrapperTop),
    wrapperContent: getWrapperComponent((_B = wrappers == null ? void 0 : wrappers.columnLeft) == null ? void 0 : _B.slotMiddle, leftColumnLayout.wrapperContent),
    wrapperBottom: getWrapperComponent((_C = wrappers == null ? void 0 : wrappers.columnLeft) == null ? void 0 : _C.slotBottom, leftColumnLayout.wrapperBottom)
  });
  const columnCenterProps = __spreadProps$c(__spreadValues$d({}, columnProps), {
    css: {
      column: __spreadValues$d(__spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.column), (_D = template == null ? void 0 : template.css) == null ? void 0 : _D.column), slotCenterBgColorValue),
      item: __spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.item), (_E = template == null ? void 0 : template.css) == null ? void 0 : _E.item)
    },
    color: slotCenterColor,
    items: slotAutoCenterElements,
    itemsBottom: slotManualBottomCenter,
    itemsTop: slotManualTopCenter,
    layout: centerColumnLayout,
    name: "Center",
    wrapperTop: getWrapperComponent((_F = wrappers == null ? void 0 : wrappers.columnCenter) == null ? void 0 : _F.slotTop, centerColumnLayout.wrapperTop),
    wrapperContent: getWrapperComponent((_G = wrappers == null ? void 0 : wrappers.columnCenter) == null ? void 0 : _G.slotMiddle, centerColumnLayout.wrapperContent),
    wrapperBottom: getWrapperComponent((_H = wrappers == null ? void 0 : wrappers.columnCenter) == null ? void 0 : _H.slotBottom, centerColumnLayout.wrapperBottom)
  });
  const columnRightProps = __spreadProps$c(__spreadValues$d({}, columnProps), {
    css: {
      column: __spreadValues$d(__spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.column), (_I = template == null ? void 0 : template.css) == null ? void 0 : _I.column), slotRightBgColorValue),
      item: __spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.item), (_J = template == null ? void 0 : template.css) == null ? void 0 : _J.item)
    },
    color: slotRightColor,
    items: slotAutoRightElements,
    itemsBottom: slotManualBottomRight,
    itemsTop: slotManualTopRight,
    layout: rightColumnLayout,
    name: "Right",
    wrapperTop: getWrapperComponent((_K = wrappers == null ? void 0 : wrappers.columnRight) == null ? void 0 : _K.slotTop, rightColumnLayout.wrapperTop),
    wrapperContent: getWrapperComponent((_L = wrappers == null ? void 0 : wrappers.columnRight) == null ? void 0 : _L.slotMiddle, rightColumnLayout.wrapperContent),
    wrapperBottom: getWrapperComponent((_M = wrappers == null ? void 0 : wrappers.columnRight) == null ? void 0 : _M.slotBottom, rightColumnLayout.wrapperBottom)
  });
  const columnExtraProps = __spreadProps$c(__spreadValues$d({}, columnProps), {
    css: {
      column: __spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.column), (_N = template == null ? void 0 : template.css) == null ? void 0 : _N.column),
      item: __spreadValues$d(__spreadValues$d({}, css == null ? void 0 : css.item), (_O = template == null ? void 0 : template.css) == null ? void 0 : _O.item)
    },
    items: slotManualExtra,
    name: "Extra",
    wrapperTop: getWrapperComponent((_P = wrappers == null ? void 0 : wrappers.columnExtra) == null ? void 0 : _P.slotTop, leftColumnLayout.wrapperTop),
    wrapperContent: getWrapperComponent((_Q = wrappers == null ? void 0 : wrappers.columnExtra) == null ? void 0 : _Q.slotMiddle, leftColumnLayout.wrapperContent),
    wrapperBottom: getWrapperComponent((_R = wrappers == null ? void 0 : wrappers.columnExtra) == null ? void 0 : _R.slotBottom, leftColumnLayout.wrapperBottom)
  });
  return /* @__PURE__ */ React__default["default"].createElement(PageBlockContainer, __spreadProps$c(__spreadValues$d({}, containerProps), {
    css: containerCss
  }), slotManualExtraTop && slotManualExtraTop.length > 0 && /* @__PURE__ */ React__default["default"].createElement(ColumnHolder, __spreadProps$c(__spreadValues$d({}, columnHolderProps), {
    css: columnHolderCss
  }), /* @__PURE__ */ React__default["default"].createElement(Column, __spreadValues$d({}, columnExtraTopProps))), /* @__PURE__ */ React__default["default"].createElement(ColumnHolder, __spreadProps$c(__spreadValues$d({}, columnHolderProps), {
    css: columnHolderCss
  }), /* @__PURE__ */ React__default["default"].createElement(Column, __spreadValues$d({}, columnLeftProps)), /* @__PURE__ */ React__default["default"].createElement(Column, __spreadValues$d({}, columnCenterProps)), /* @__PURE__ */ React__default["default"].createElement(Column, __spreadValues$d({}, columnRightProps))), slotManualExtra && slotManualExtra.length > 0 && /* @__PURE__ */ React__default["default"].createElement(ColumnHolder, __spreadProps$c(__spreadValues$d({}, columnHolderProps), {
    css: columnHolderCss
  }), /* @__PURE__ */ React__default["default"].createElement(Column, __spreadValues$d({}, columnExtraProps))));
};
PageBlock.defaultProps = {
  itemComponent: Item
};

const SideMenuHeader = PrensaEngine.styled("header", {});
const SideMenuContent = PrensaEngine.styled("section", {});
const SideMenuFooter = PrensaEngine.styled("footer", {});

const SideMenu = ({ css, open, close, innerSpace, sections, size }) => {
  return /* @__PURE__ */ React__default["default"].createElement(Drawer, {
    close,
    open,
    size,
    innerSpace,
    css: css == null ? void 0 : css.drawer
  }, /* @__PURE__ */ React__default["default"].createElement(SideMenuHeader, {
    css: css == null ? void 0 : css.header
  }, sections && sections.header), /* @__PURE__ */ React__default["default"].createElement(SideMenuContent, {
    css: css == null ? void 0 : css.content
  }, sections && sections.content), /* @__PURE__ */ React__default["default"].createElement(SideMenuFooter, {
    css: css == null ? void 0 : css.footer
  }, sections && sections.footer));
};
SideMenu.defaultProps = {
  size: "lg"
};

var __defProp$c = Object.defineProperty;
var __defProps$b = Object.defineProperties;
var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$b = (a, b) => __defProps$b(a, __getOwnPropDescs$b(b));
const ImageContainer = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$b(__spreadValues$c({}, customProps), {
  className: `TeaserImageContainer ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$c(__spreadValues$c({}, defaultCss), css)
}), children);
ImageContainer.defaultProps = {
  defaultCss: {
    align: ["column", "left", "top"],
    aspectRatio: 2 / 1,
    backgroundColor: "$basicBlackAlpha100",
    width: "100%"
  }
};
const ImageWrap = ({
  css,
  customProps,
  defaultCss,
  image,
  wrapImage
}) => {
  const WrapImage = wrapImage;
  return /* @__PURE__ */ React__default["default"].createElement(Block, {
    className: `TeaserImage ${(customProps == null ? void 0 : customProps.className) || ""}`,
    css: __spreadValues$c(__spreadValues$c({}, defaultCss), css)
  }, WrapImage ? /* @__PURE__ */ React__default["default"].createElement(WrapImage, __spreadValues$c({}, image)) : /* @__PURE__ */ React__default["default"].createElement("img", {
    alt: image == null ? void 0 : image.alt,
    src: image == null ? void 0 : image.url
  }));
};
ImageWrap.defaultProps = {
  defaultCss: {
    align: ["column", "center", "top"],
    my: 0,
    width: "100%",
    img: {
      width: "100%"
    }
  }
};

var __defProp$b = Object.defineProperty;
var __defProps$a = Object.defineProperties;
var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$a = (a, b) => __defProps$a(a, __getOwnPropDescs$a(b));
const Image = ({
  css,
  customProps,
  derivative,
  image,
  wrapImage
}) => {
  var _a;
  const aspectRatio = derivative === "1x1" ? 1 / 1 : derivative === "2x1" ? 2 / 1 : derivative === "3x1" ? 3 / 1 : derivative === "3x2" ? 3 / 2 : derivative === "1x2" ? 1 / 2 : derivative === "1x3" ? 1 / 3 : derivative === "2x3" ? 2 / 3 : css == null ? void 0 : css.aspectRatio;
  const imageUrl = ((_a = image == null ? void 0 : image.url) == null ? void 0 : _a.endsWith("?")) ? `${image == null ? void 0 : image.url}f=${derivative}` : `${image == null ? void 0 : image.url}&f=${derivative}`;
  const imageParsed = __spreadProps$a(__spreadValues$b({}, image), { url: imageUrl });
  return /* @__PURE__ */ React__default["default"].createElement(ImageContainer, {
    css: __spreadProps$a(__spreadValues$b({}, css), {
      aspectRatio
    }),
    customProps
  }, /* @__PURE__ */ React__default["default"].createElement(ImageWrap, {
    image: imageParsed,
    wrapImage
  }));
};

var __defProp$a = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$9 = (a, b) => __defProps$9(a, __getOwnPropDescs$9(b));
const NumberContainer = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$9(__spreadValues$a({}, customProps), {
  className: `TeaserNumber ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$a(__spreadValues$a({}, defaultCss), css)
}), children);
NumberContainer.defaultProps = {
  defaultCss: {
    align: ["column", "left", "top"],
    width: "100%"
  }
};
const NumberText = ({
  css,
  children,
  customProps,
  defaultCss,
  variant
}) => /* @__PURE__ */ React__default["default"].createElement(Typography, {
  as: "span",
  className: `TeaserNumberText ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$a(__spreadValues$a({}, defaultCss), css),
  variant
}, children);
NumberText.defaultProps = {
  defaultCss: {
    align: ["column", "center", "top"],
    my: 0
  }
};

var __defProp$9 = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$8 = (a, b) => __defProps$8(a, __getOwnPropDescs$8(b));
const Number = ({
  bgColor,
  color,
  children,
  css,
  customProps,
  textVariant,
  variant
}) => {
  let containerCss = {};
  let variantCss = css || {};
  if (variant === "default") {
    variantCss = {
      color: `$${color}`
    };
  }
  if (variant === "filled") {
    containerCss = __spreadProps$8(__spreadValues$9({}, css), {
      backgroundColor: `$${bgColor}`
    });
    variantCss = {
      color: `$${color}`
    };
  }
  return /* @__PURE__ */ React__default["default"].createElement(NumberContainer, {
    css: containerCss,
    customProps
  }, /* @__PURE__ */ React__default["default"].createElement(NumberText, {
    css: variantCss,
    variant: textVariant
  }, children));
};

var __defProp$8 = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
const RelatedContainer = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$7(__spreadValues$8({}, customProps), {
  className: `TeaserRelated ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$8(__spreadValues$8({}, defaultCss), css)
}), children);
RelatedContainer.defaultProps = {
  defaultCss: {
    align: ["column", "left", "top"],
    width: "100%"
  }
};

var __defProp$7 = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
const Related = ({
  css,
  customProps,
  items,
  layout
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(RelatedContainer, {
    css,
    customProps
  }, lodash.map(items, (item, key) => /* @__PURE__ */ React__default["default"].createElement(Teaser, __spreadProps$6(__spreadValues$7(__spreadValues$7({}, layout), item), {
    key
  }))));
};

var __defProp$6 = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
const TeaserStyled = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$5(__spreadValues$6({}, customProps), {
  className: `Teaser ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$6(__spreadValues$6({}, defaultCss), css)
}), children);
TeaserStyled.defaultProps = {
  defaultCss: {
    align: ["column", "left", "top"],
    backgroundColor: "$basicWhiteAlpha900",
    p: "$4",
    width: "calc(100% - $8)"
  }
};
const TeaserWrap = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$5(__spreadValues$6({}, customProps), {
  className: `TeaserWrap ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$6(__spreadValues$6({}, defaultCss), css)
}), children);
TeaserWrap.defaultProps = {
  defaultCss: {
    align: ["column", "left", "top"],
    width: "100%"
  }
};

var __defProp$5 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
const SubjectContainer = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$4(__spreadValues$5({}, customProps), {
  className: `TeaserSubject ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$5(__spreadValues$5({}, defaultCss), css)
}), children);
SubjectContainer.defaultProps = {
  defaultCss: {
    align: ["column", "left", "top"],
    width: "100%"
  }
};
const SubjectText = ({
  css,
  children,
  customProps,
  defaultCss,
  variant
}) => /* @__PURE__ */ React__default["default"].createElement(Typography, {
  as: "p",
  className: `TeaserSubjectText ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$5(__spreadValues$5({}, defaultCss), css),
  variant
}, children);
SubjectText.defaultProps = {
  defaultCss: {
    align: ["column", "center", "top"],
    my: 0
  },
  variant: "subject-default"
};

const Subject = ({
  bgColor,
  color,
  children,
  css,
  customProps,
  subject,
  textVariant,
  variant
}) => {
  let variantCss = {};
  if (variant === "default") {
    variantCss = {
      color: `$${color}`
    };
  }
  if (variant === "filled") {
    variantCss = {
      backgroundColor: `$${bgColor}`,
      color: `$${color}`
    };
  }
  return /* @__PURE__ */ React__default["default"].createElement(SubjectContainer, {
    css,
    customProps
  }, /* @__PURE__ */ React__default["default"].createElement(SubjectText, {
    css: variantCss,
    variant: textVariant
  }, subject || children));
};

var __defProp$4 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
const SubtitleContainer = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$3(__spreadValues$4({}, customProps), {
  className: `TeaserSubtitle ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$4(__spreadValues$4({}, defaultCss), css)
}), children);
SubtitleContainer.defaultProps = {
  defaultCss: {
    align: ["column", "left", "top"],
    width: "100%"
  }
};
const SubtitleText = ({
  css,
  children,
  customProps,
  defaultCss,
  variant
}) => /* @__PURE__ */ React__default["default"].createElement(Typography, {
  as: "p",
  className: `TeaserSubtitleText ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$4(__spreadValues$4({}, defaultCss), css),
  variant
}, children);
SubtitleText.defaultProps = {
  defaultCss: {
    align: ["column", "center", "top"],
    my: 0
  },
  variant: "subtitle-default"
};

const Subtitle = ({
  children,
  css,
  customProps,
  subtitle,
  variant
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(SubtitleContainer, {
    css,
    customProps
  }, /* @__PURE__ */ React__default["default"].createElement(SubtitleText, {
    variant
  }, subtitle || children));
};

var __defProp$3 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
const TitleContainer = ({
  css,
  children,
  customProps,
  defaultCss
}) => /* @__PURE__ */ React__default["default"].createElement(Block, __spreadProps$2(__spreadValues$3({}, customProps), {
  className: `TeaserTitle ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$3(__spreadValues$3({}, defaultCss), css)
}), children);
TitleContainer.defaultProps = {
  defaultCss: {
    align: ["column", "left", "top"],
    width: "100%"
  }
};
const TitleText = ({
  css,
  children,
  customProps,
  defaultCss,
  variant
}) => /* @__PURE__ */ React__default["default"].createElement(Typography, {
  as: "p",
  className: `TeaserTitleText ${(customProps == null ? void 0 : customProps.className) || ""}`,
  css: __spreadValues$3(__spreadValues$3({}, defaultCss), css),
  variant
}, children);
TitleText.defaultProps = {
  defaultCss: {
    align: ["column", "center", "top"],
    my: 0
  },
  variant: "newstitle-sm"
};

const Title = ({
  children,
  css,
  customLink,
  customLinkProps,
  customProps,
  color,
  icon,
  path,
  title,
  variant
}) => {
  return /* @__PURE__ */ React__default["default"].createElement(TitleContainer, {
    css,
    customProps
  }, (icon == null ? void 0 : icon.enabled) && (icon == null ? void 0 : icon.useIcon({ icon: icon.name, color: color || "" })), /* @__PURE__ */ React__default["default"].createElement(TitleText, {
    variant
  }, /* @__PURE__ */ React__default["default"].createElement(Link, {
    title,
    href: path,
    component: customLink,
    componentProps: customLinkProps
  }, title || children)));
};

var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
const Teaser = ({
  css,
  components,
  customLink,
  customLinkProps,
  customProps,
  image,
  imageDerivative,
  imageVariant,
  numberBgColor,
  numberColor,
  numberVariant,
  numberValue,
  path,
  relatedIcon,
  relatedItems,
  relatedLayout,
  slotColor,
  subject,
  subjectBgColor,
  subjectColor,
  subjectCss,
  subjectTextVariant,
  subjectVariant,
  subtitle,
  subtitleVariant,
  title,
  titleVariant,
  wrapImage
}) => {
  const TeaserNumber = components == null ? void 0 : components.number;
  const TeaserNumberProps = {
    bgColor: numberBgColor,
    color: numberColor,
    children: numberValue,
    variant: numberVariant
  };
  const TeaserImage = components == null ? void 0 : components.image;
  const TeaserImageProps = {
    alt: title,
    derivative: imageDerivative,
    image,
    wrapImage
  };
  const TeaserRelated = components == null ? void 0 : components.related;
  const TeaserRelatedProps = {
    items: relatedItems,
    layout: __spreadProps$1(__spreadValues$2({}, relatedLayout), {
      customLink,
      customLinkProps,
      slotColor
    })
  };
  const TeaserSubject = components == null ? void 0 : components.subject;
  const TeaserSubjectProps = {
    bgColor: subjectBgColor,
    color: subjectColor,
    css: subjectCss,
    subject,
    textVariant: subjectTextVariant,
    variant: subjectVariant
  };
  const TeaserSubtitle = components == null ? void 0 : components.subtitle;
  const TeaserSubtitleProps = {
    subtitle,
    variant: subtitleVariant
  };
  const TeaserTitle = components == null ? void 0 : components.title;
  const TeaserTitleProps = {
    customLink,
    customLinkProps,
    color: slotColor,
    icon: relatedIcon,
    path,
    title,
    variant: titleVariant
  };
  const TeaserStyledAlign = imageVariant === "left" ? { align: ["row", "left", "top"] } : imageVariant === "top" ? { align: ["column", "left", "top"] } : imageVariant === "right" ? { align: ["row-reverse", "right", "top"] } : imageVariant === "bottom" ? { align: ["column-reverse", "left", "top"] } : {};
  const TeaserStyledProps = {
    css: __spreadValues$2(__spreadValues$2({}, css), TeaserStyledAlign),
    customProps
  };
  const TeaserWrapContent = TeaserWrap;
  return /* @__PURE__ */ React__default["default"].createElement(TeaserStyled, __spreadValues$2({}, TeaserStyledProps), TeaserNumber && numberVariant !== "none" && /* @__PURE__ */ React__default["default"].createElement(TeaserNumber, __spreadValues$2({}, TeaserNumberProps)), TeaserImage && numberVariant == "none" && imageVariant && /* @__PURE__ */ React__default["default"].createElement(TeaserImage, __spreadValues$2({}, TeaserImageProps)), /* @__PURE__ */ React__default["default"].createElement(TeaserWrapContent, null, TeaserSubject && /* @__PURE__ */ React__default["default"].createElement(TeaserSubject, __spreadValues$2({}, TeaserSubjectProps)), TeaserTitle && /* @__PURE__ */ React__default["default"].createElement(TeaserTitle, __spreadValues$2({}, TeaserTitleProps)), TeaserSubtitle && /* @__PURE__ */ React__default["default"].createElement(TeaserSubtitle, __spreadValues$2({}, TeaserSubtitleProps)), TeaserRelated && relatedItems && relatedLayout && /* @__PURE__ */ React__default["default"].createElement(TeaserRelated, __spreadValues$2({}, TeaserRelatedProps))));
};
Teaser.defaultProps = {
  components: {
    image: Image,
    number: Number,
    related: Related,
    subject: Subject,
    subtitle: Subtitle,
    title: Title
  },
  numberVariant: "none"
};

const TopbarContainer = PrensaEngine.styled("header", {
  align: ["column", "center", "middle"],
  boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.1)",
  width: "100%"
});
PrensaEngine.styled("div", {
  align: ["row", "center", "between"],
  height: "$10",
  width: "100%"
});
PrensaEngine.styled("div", {
  align: ["row", "center", "between"],
  height: "$10",
  width: "100%"
});
const SlotBottomContainer = PrensaEngine.styled("div", {
  align: ["row", "center", "between"],
  height: "$10",
  width: "100%"
});
PrensaEngine.styled("div", {});
PrensaEngine.styled("div", {});
PrensaEngine.styled("div", {});
PrensaEngine.styled("div", {});
PrensaEngine.styled("div", {});
PrensaEngine.styled("div", {});
const SlotBottomLeftContainer = PrensaEngine.styled("div", {});
const SlotBottomCenterContainer = PrensaEngine.styled("div", {});
const SlotBottomRightContainer = PrensaEngine.styled("div", {});

const Topbar = (props) => {
  const {
    children,
    css,
    slotBottomCenter,
    slotBottomLeft,
    slotBottomRight,
    slotMiddleCenter,
    slotMiddleLeft,
    slotMiddleRight,
    slotTopCenter,
    slotTopLeft,
    slotTopRight
  } = props;
  const SlotTopLeft = slotTopLeft;
  const SlotTopCenter = slotTopCenter;
  const SlotTopRight = slotTopRight;
  const SlotMiddleLeft = slotMiddleLeft;
  const SlotMiddleCenter = slotMiddleCenter;
  const SlotMiddleRight = slotMiddleRight;
  const SlotBottomLeft = slotBottomLeft;
  const SlotBottomCenter = slotBottomCenter;
  const SlotBottomRight = slotBottomRight;
  const renderTopbarSlot = ({ name, css: css2, SlotLeft, SlotCenter, SlotRight }) => {
    const { containerCss, leftContainerCss, centerContainerCss, rightContainerCss } = css2;
    return /* @__PURE__ */ React__default["default"].createElement(SlotBottomContainer, {
      className: `pds-Topbar-${name}Container`,
      css: containerCss
    }, /* @__PURE__ */ React__default["default"].createElement(SlotBottomLeftContainer, {
      className: `pds-Topbar-${name}LeftContainer`,
      css: leftContainerCss
    }, useComponentFromProps({ component: SlotLeft, componentProps: {} })), /* @__PURE__ */ React__default["default"].createElement(SlotBottomCenterContainer, {
      className: `pds-Topbar-${name}CenterContainer`,
      css: centerContainerCss
    }, useComponentFromProps({ component: SlotCenter, componentProps: {} })), /* @__PURE__ */ React__default["default"].createElement(SlotBottomRightContainer, {
      className: `pds-Topbar-${name}RightContainer`,
      css: rightContainerCss
    }, useComponentFromProps({ component: SlotRight, componentProps: {} })));
  };
  return /* @__PURE__ */ React__default["default"].createElement(TopbarContainer, {
    className: "pds-Topbar-Container",
    css: css == null ? void 0 : css.cssContainer
  }, /* @__PURE__ */ React__default["default"].createElement(Block, {
    css: css == null ? void 0 : css.cssContainerTopHolder
  }, slotTopLeft || slotTopCenter || slotTopRight ? renderTopbarSlot({
    name: "SlotTop",
    css: {
      containerCss: css == null ? void 0 : css.cssContainerTop,
      leftContainerCss: css == null ? void 0 : css.cssContainerTopSlotLeft,
      centerContainerCss: css == null ? void 0 : css.cssContainerTopSlotCenter,
      rightContainerCss: css == null ? void 0 : css.cssContainerTopSlotRight
    },
    SlotLeft: SlotTopLeft,
    SlotCenter: SlotTopCenter,
    SlotRight: SlotTopRight
  }) : null), /* @__PURE__ */ React__default["default"].createElement(Block, {
    css: css == null ? void 0 : css.cssContainerMiddleHolder
  }, renderTopbarSlot({
    name: "SlotMiddle",
    css: {
      containerCss: css == null ? void 0 : css.cssContainerMiddle,
      leftContainerCss: css == null ? void 0 : css.cssContainerMiddleSlotLeft,
      centerContainerCss: css == null ? void 0 : css.cssContainerMiddleSlotCenter,
      rightContainerCss: css == null ? void 0 : css.cssContainerMiddleSlotRight
    },
    SlotLeft: SlotMiddleLeft,
    SlotCenter: SlotMiddleCenter,
    SlotRight: SlotMiddleRight
  })), /* @__PURE__ */ React__default["default"].createElement(Block, {
    css: css == null ? void 0 : css.cssContainerBottomHolder
  }, slotBottomLeft || slotBottomCenter || slotBottomRight ? renderTopbarSlot({
    name: "SlotBottom",
    css: {
      containerCss: css == null ? void 0 : css.cssContainerBottom,
      leftContainerCss: css == null ? void 0 : css.cssContainerBottomLeft,
      centerContainerCss: css == null ? void 0 : css.cssContainerBottomCenter,
      rightContainerCss: css == null ? void 0 : css.cssContainerBottomRight
    },
    SlotLeft: SlotBottomLeft,
    SlotCenter: SlotBottomCenter,
    SlotRight: SlotBottomRight
  }) : null), children);
};

const pageblockConfig = {
  slotManualBottomLeft: [],
  slotManualBottomCenter: [],
  slotManualBottomRight: [],
  slotManualExtra: [],
  slotManualExtraTop: [],
  slotManualTopLeft: [],
  slotManualTopCenter: [],
  slotManualTopRight: [],
  slotLeftComponent: "",
  slotLeftIconValue: "",
  slotLeftReadMoreEnabled: false,
  slotLeftReadMoreLink: "",
  slotLeftReadMoreTitle: "",
  slotLeftTeaserBgColor: "background1",
  slotLeftTitleEnabled: false,
  slotLeftTitleLink: "",
  slotLeftTitleValue: "",
  slotCenterComponent: "",
  slotCenterIconValue: "",
  slotCenterReadMoreEnabled: false,
  slotCenterReadMoreLink: "",
  slotCenterReadMoreTitle: "",
  slotCenterTeaserBgColor: "background1",
  slotCenterTitleEnabled: false,
  slotCenterTitleLink: "",
  slotCenterTitleValue: "",
  slotRightComponent: "",
  slotRightIconValue: "",
  slotRightReadMoreEnabled: false,
  slotRightReadMoreLink: "",
  slotRightReadMoreTitle: "",
  slotRightTeaserBgColor: "background1",
  slotRightTitleValue: "",
  slotRightTitleEnabled: false,
  slotRightTitleLink: ""
};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const alignToCenter = {
  textAlign: "center",
  ".TeaserSubject": {
    align: ["column", "center", "top"]
  },
  ".TeaserSubtitle": {
    align: ["column", "center", "top"]
  }
};
const TeaserRelated = {
  css: {
    p: 0,
    ".TeaserImageContainer": {
      display: "none"
    },
    ".TeaserSubject": {
      display: "none"
    },
    ".TeaserSubtitle": {
      display: "none"
    },
    ".TeaserTitle": {
      align: ["row", "center", "top"]
    },
    ".TeaserTitleText": {
      align: ["row", "center", "top"],
      mb: "$2"
    },
    ".TeaserTitleText:before": {
      content: "\u{1F340}"
    }
  },
  className: "TeaserRelated",
  titleVariant: "newstitle-md"
};
const TeaserHeadlineSm = {
  css: __spreadProps(__spreadValues$1({}, alignToCenter), {
    mb: "$3",
    ".TeaserImage": {
      display: "none"
    }
  }),
  className: "TeaserHeadlineSm",
  relatedLayout: TeaserRelated,
  subjectBgColor: "basicSuccess800",
  subjectColor: "basicWhite",
  subjectVariant: "filled",
  subtitleVariant: "subtitle-desktop",
  titleVariant: "newstitle-5xl"
};
const TeaserHeadlineLg = {
  css: __spreadProps(__spreadValues$1({}, alignToCenter), {
    mb: "$3",
    ".TeaserImage": {
      display: "none"
    },
    ".TeaserRelated": {
      align: ["row", "center", "top"]
    }
  }),
  className: "TeaserHeadlineLg",
  relatedLayout: TeaserRelated,
  subjectColor: "brandTertiary400",
  subjectVariant: "default",
  subtitleVariant: "subtitle-desktop",
  titleVariant: "newstitle-6xl"
};
const TeaserImageBottom = {
  css: {
    mb: "$3",
    ".TeaserImageContainer": {
      mt: "$3"
    }
  },
  className: "TeaserImageBottom",
  imageDerivative: "3x1",
  imageVariant: "bottom",
  subtitleVariant: "subtitle-desktop",
  subjectVariant: "filled",
  titleVariant: "newstitle-5xl"
};
const TeaserImageLeft = {
  css: {
    mb: "$3",
    ".TeaserImageContainer": {
      maxWidth: "140px",
      mr: "$3"
    }
  },
  className: "TeaserImageLeft",
  imageDerivative: "1x1",
  imageVariant: "left",
  subjectVariant: "filled",
  subtitleVariant: "subtitle-desktop",
  titleVariant: "newstitle-md"
};
const TeaserImageRight = {
  css: {
    mb: "$3",
    ".TeaserImageContainer": {
      maxWidth: "100px",
      ml: "$3"
    }
  },
  className: "TeaserImageRight",
  imageDerivative: "1x1",
  imageVariant: "right",
  subjectVariant: "filled",
  subtitleVariant: "subtitle-desktop",
  titleVariant: "newstitle-md"
};
const TeaserImageRightLg = __spreadProps(__spreadValues$1({}, TeaserImageRight), {
  css: {
    mb: "$3",
    ".TeaserImageContainer": {
      maxWidth: "240px",
      ml: "$3"
    }
  },
  imageDerivative: "3x2",
  titleVariant: "newstitle-3xl"
});
const TeaserImageTop = {
  css: {
    mb: "$3",
    ".TeaserImageContainer": {
      mb: "$3"
    }
  },
  className: "TeaserImageTop",
  imageDerivative: "3x1",
  imageVariant: "top",
  subjectVariant: "filled",
  subtitleVariant: "subtitle-desktop",
  titleVariant: "newstitle-xl"
};
const TeaserNumber = {
  className: "TeaserNumber",
  imageVariant: "left",
  numberBgColor: "basicError300",
  numberColor: "basicWhiteAlpha800",
  numberVariant: "filled",
  numberValue: "222",
  css: {
    ".TeaserSubtitle": {
      display: "none"
    },
    ".TeaserNumber": {
      align: ["row", "center", "middle"],
      borderRadius: "$circle",
      fontFamily: "$primary",
      fontSize: "24px",
      height: "100px",
      width: "100px"
    },
    ".TeaserWrap": {
      ml: "24px",
      width: "calc(100% - 124px)"
    }
  }
};
const TeaserHeadlineImageSm = {
  className: "TeaserHeadlineImage",
  imageDerivative: "1x1",
  imageVariant: "background",
  subjectVariant: "filled",
  titleVariant: "newstitle-2xl",
  css: {
    position: "relative",
    ".TeaserImage": {
      backgroundColor: "$basicBlackAlpha400"
    },
    ".TeaserSubtitle": {
      display: "none"
    },
    ".TeaserTitleText": {
      color: "$basicWhite",
      textShadow: "rgb(0 0 0 / 50%) 2px 2px 3px"
    },
    ".TeaserWrap": {
      align: ["column", "left", "bottom"],
      aspectRatio: "1 / 1",
      background: "linear-gradient(rgba(0, 0, 0, 0) 43.75%, rgb(0, 0, 0) 100%)",
      position: "absolute",
      p: "$4",
      height: "calc(100% - 64px)",
      width: "calc(100% - 64px)"
    }
  }
};
const TeaserHeadlineImageMd = {
  className: "TeaserHeadlineImage",
  imageDerivative: "1x1",
  imageVariant: "background",
  subjectVariant: "filled",
  titleVariant: "newstitle-4xl",
  css: {
    position: "relative",
    ".TeaserImage": {},
    ".TeaserSubtitle": {
      display: "none"
    },
    ".TeaserTitleText": {
      color: "$basicWhite",
      textShadow: "rgb(0 0 0 / 50%) 2px 2px 3px"
    },
    ".TeaserWrap": {
      align: ["column", "left", "bottom"],
      aspectRatio: "1 / 1",
      background: "linear-gradient(rgba(0, 0, 0, 0) 43.75%, rgb(0, 0, 0) 100%)",
      position: "absolute",
      p: "$4",
      height: "calc(100% - 64px)",
      width: "calc(100% - 64px)"
    }
  }
};
const TeaserHeadlineImageLg = {
  className: "TeaserHeadlineImage",
  imageDerivative: "3x1",
  imageVariant: "background",
  subtitleVariant: "newstitle-3xl",
  subjectVariant: "filled",
  titleVariant: "newstitle-6xl",
  css: {
    position: "relative",
    ".TeaserSubtitleText": {
      color: "$basicWhite",
      textShadow: "rgb(0 0 0 / 50%) 2px 2px 3px"
    },
    ".TeaserTitleText": {
      color: "$basicWhite",
      textShadow: "rgb(0 0 0 / 50%) 2px 2px 3px"
    },
    ".TeaserWrap": {
      align: ["column", "left", "bottom"],
      aspectRatio: "3 / 1",
      background: "linear-gradient(rgba(0, 0, 0, 0) 43.75%, rgb(0, 0, 0) 100%)",
      position: "absolute",
      p: "$4",
      height: "calc(100% - 64px)",
      width: "calc(100% - 64px)"
    }
  }
};
const teasers = {
  TeaserHeadlineImageSm,
  TeaserHeadlineImageMd,
  TeaserHeadlineImageLg,
  TeaserHeadlineSm,
  TeaserHeadlineLg,
  TeaserImageBottom,
  TeaserImageLeft,
  TeaserImageRight,
  TeaserImageRightLg,
  TeaserImageTop,
  TeaserRelated,
  TeaserNumber
};
const teasersKeys = Object.keys(teasers);

const LayoutDefault = {
  css: {
    column: {
      align: ["row", "center", "top"],
      flexWrap: "wrap",
      width: "100%",
      "@lg": {
        align: ["row", "between", "top"]
      }
    }
  },
  customProps: {
    column: {
      className: "MyLayoutColumn"
    },
    item: {
      className: "MyLayoutItem"
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        default: [teasers.TeaserHeadlineSm, teasers.TeaserImageRight]
      }
    }
  }
};
const LayoutFeatured = {
  css: {
    column: {
      align: ["column", "center", "top"],
      width: "100%"
    },
    item: {
      mb: "$3"
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        default: [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineLg]
      }
    },
    Template7030: {
      slotLeft: {
        "default": [teasers.TeaserImageRight, teasers.TeaserImageRight],
        "1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineLg],
        "2": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm],
        "2:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineLg],
        "3:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineLg],
        "3:2": [teasers.TeaserImageRight, teasers.TeaserHeadlineSm],
        "4:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineLg],
        "4:2": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm]
      },
      slotCenter: {
        default: [teasers.TeaserImageRight, teasers.TeaserImageRight],
        "1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineImageSm]
      }
    },
    Template30: {
      slotLeft: {
        default: [teasers.TeaserImageRight, teasers.TeaserImageRight],
        "1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm],
        "2:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm],
        "3:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm],
        "4:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm]
      },
      slotCenter: {
        default: [teasers.TeaserImageRight, teasers.TeaserImageRight],
        "1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm],
        "2:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm],
        "3:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm],
        "4:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm]
      },
      slotRight: {
        default: [teasers.TeaserImageRight, teasers.TeaserImageRight],
        "1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm],
        "2:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm],
        "3:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm],
        "4:1": [teasers.TeaserHeadlineSm, teasers.TeaserHeadlineSm]
      }
    }
  }
};
const LayoutGrid = {
  css: {
    column: {
      "@lg": {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "$4"
      }
    }
  }
};
const LayoutMostRead = {
  css: {
    column: {
      align: ["column", "center", "top"],
      width: "100%"
    },
    item: {
      mb: "$3"
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        default: [teasers.TeaserNumber, teasers.TeaserNumber]
      }
    },
    Template7030: {
      slotLeft: {
        default: [teasers.TeaserNumber, teasers.TeaserNumber]
      },
      slotCenter: {
        default: [teasers.TeaserNumber, teasers.TeaserNumber]
      }
    },
    Template30: {
      slotLeft: {
        default: [teasers.TeaserNumber, teasers.TeaserNumber]
      },
      slotCenter: {
        default: [teasers.TeaserNumber, teasers.TeaserNumber]
      },
      slotRight: {
        default: [teasers.TeaserNumber, teasers.TeaserNumber]
      }
    }
  }
};
const layouts = { LayoutDefault, LayoutFeatured, LayoutGrid, LayoutMostRead };
const layoutsKeys = Object.keys(layouts);

const Template100 = {
  css: {
    container: {
      backgroundColor: "$basicBlackAlpha100",
      py: "$3",
      width: "100%"
    },
    columnHolder: {
      "@lg": {
        align: ["row", "between", "top"],
        backgroundColor: "$basicBlackAlpha100",
        maxWidth: "1280px",
        width: "calc(100% - $8)"
      },
      ".Column:nth-child(2)": {
        display: "none"
      },
      ".Column:nth-child(3)": {
        display: "none"
      }
    }
  }
};
const Template7030 = {
  css: {
    container: {
      backgroundColor: "$basicBlackAlpha100",
      py: "$3",
      width: "100%"
    },
    columnHolder: {
      "@lg": {
        align: ["row", "between", "top"],
        backgroundColor: "$basicBlackAlpha100",
        maxWidth: "1280px",
        width: "calc(100% - $8)",
        ".Column:nth-child(1)": {
          width: "calc(calc(calc(100% - $4) / 3) * 2)"
        },
        ".Column:nth-child(2)": {
          width: "calc(calc(calc(100% - $4) / 3) * 1)"
        }
      },
      ".Column:nth-child(3)": {
        display: "none"
      }
    }
  }
};
const Template30 = {
  css: {
    container: {
      backgroundColor: "$basicBlackAlpha100",
      py: "$3",
      width: "100%"
    },
    columnHolder: {
      "@lg": {
        align: ["row", "between", "top"],
        backgroundColor: "$basicBlackAlpha100",
        maxWidth: "1280px",
        width: "calc(100% - $8)",
        ".Column:nth-child(1)": {
          width: "calc(calc(calc(100% - $8) / 3) * 1)"
        },
        ".Column:nth-child(2)": {
          width: "calc(calc(calc(100% - $8) / 3) * 1)"
        },
        ".Column:nth-child(3)": {
          width: "calc(calc(calc(100% - $8) / 3) * 1)"
        }
      }
    },
    column: {
      "@lg": {
        width: "calc(calc(100% - $6) / 3)"
      }
    }
  },
  customProps: {
    container: {
      className: "Template7030"
    }
  }
};
const templates = { Template100, Template7030, Template30 };
const templatesKeys = Object.keys(templates);

const LayoutProviderDefaults = {
  layouts,
  layoutsKeys,
  pageBlock: pageblockConfig,
  teasers,
  teasersKeys,
  templates,
  templatesKeys
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LayoutProvider = (_a) => {
  var _b = _a, { children } = _b, otherProps = __objRest$1(_b, ["children"]);
  return /* @__PURE__ */ React__default["default"].createElement("div", {
    className: "pds-LayoutProvider-root"
  }, React__default["default"].Children.map(children, (item) => React__default["default"].cloneElement(item, __spreadValues({
    layouts: LayoutProviderDefaults.layouts,
    teasers: LayoutProviderDefaults.teasers,
    templates: LayoutProviderDefaults.templates,
    pageBlockConfig: LayoutProviderDefaults.pageBlock
  }, otherProps))));
};

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PrensaThemeProvider = (props) => {
  const _a = props, { children, theme } = _a, otherProps = __objRest(_a, ["children", "theme"]);
  const selectedTheme = theme ? PrensaEngine.createTheme("prensa-ds", theme) : PrensaEngine.createTheme("prensa-ds", PrensaEngine.config.theme);
  return /* @__PURE__ */ React__default["default"].createElement("div", {
    className: selectedTheme.className
  }, React__default["default"].Children.map(children, (item) => React__default["default"].cloneElement(item, otherProps)));
};

exports.Accordion = Accordion;
exports.AccordionContent = AccordionContent;
exports.AccordionGroup = AccordionGroup;
exports.AccordionItemGroup = AccordionItemGroup;
exports.Block = Block;
exports.Button = Button;
exports.Calendar = Calendar;
exports.Carousel = Carousel;
exports.Drawer = Drawer;
exports.DrawerBackdrop = DrawerBackdrop;
exports.DrawerContainer = DrawerContainer;
exports.DrawerContent = DrawerContent;
exports.DrawerSpacer = DrawerSpacer;
exports.Footer = Footer;
exports.IconButton = IconButton;
exports.ImageGallery = ImageGallery;
exports.LayoutProvider = LayoutProvider;
exports.LayoutProviderDefaults = LayoutProviderDefaults;
exports.Link = Link;
exports.PageBlock = PageBlock;
exports.PrensaEngine = PrensaEngine;
exports.PrensaThemeProvider = PrensaThemeProvider;
exports.SideMenu = SideMenu;
exports.Tabs = Tabs;
exports.Teaser = Teaser;
exports.Topbar = Topbar;
exports.Typography = Typography;
exports.Utils = Utils;
